import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import DeleteIcon from '@mui/icons-material/Delete';
import AddUserIcon from '@mui/icons-material/Add';
import AddUserImage from '@mui/icons-material/CloudUpload';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  foldFiltersToSearchText,
  getActionsColumn,
  actionMenuItem,
  openAgGridContextMenu,
} from '../grid/iLocalAGGrid';
import Dropzone from 'react-dropzone';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {ValidatorForm, TextValidator, SelectValidator, } from 'react-material-ui-form-validator';
import {toast} from 'react-toastify';
import spinner from '../assign-prescriptions/images/spinner.gif';
import Select from '@mui/material/Select';
import Input from '@mui/material/Input';
import Chip from '@mui/material/Chip';
import ListItemText from '@mui/material/ListItemText';
import InputLabel from '@mui/material/InputLabel';
import {AppBar, Tabs, Tab, Grid, FormControl, FormControlLabel, FormGroup, Switch, Divider, FormHelperText, } from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import USER_ROLES from '../common/userroles';
import {DesktopDatePicker, LocalizationProvider} from '@mui/lab';
import DateAdapter from '@mui/lab/AdapterDateFns';
import moment from 'moment-timezone';
import {IMaskInput} from 'react-imask';
import {Box} from '@mui/system';
import {withTranslation} from 'react-i18next';
import enLocale from 'date-fns/locale/en-US';
import frLocale from 'date-fns/locale/fr';
import download from '../reports/images/download-doc.svg';
import secureBadgeImg from './images/secureBadgeImg.png';
import CloseIcon from '@mui/icons-material/Close';
import {Radio, RadioGroup} from '@mui/material';
import PrintTemplate from 'react-print';
import {Stepper, Step, StepLabel} from '@mui/material';
import userroles from '../common/userroles';
import {writeAuditLog} from '../common/apis';
import {buildUserUpdatedAuditDescription} from '../../utils/userEditAuditFields';
import ROLES_TYPE from '../enum/role_type';
import SearchableSelect from '../common/SearchableSelect';
import { navigate } from '@reach/router';


function TabContainer({ children, dir, classes }) {
  return (
    <Typography component='div' dir={dir}>
      {children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
  dir: PropTypes.string.isRequired,
};
class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {onSelectAllClick, order, orderBy, numSelected, rowCount, sortId, t} = this.props;
    const rows = [
      {
        id: 'avatar',
        numeric: false,
        disablePadding: true,
        label: t('Users.Picture'),
        field: 'picture_url',
      },
      {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: t('Users.Name'),
        field: 'name',
      },
      {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: t('Users.UserName'),
        field: 'username',
      },
      {
        id: 'parent_account',
        numeric: false,
        disablePadding: false,
        label: t('Users.AssociatedAccount'),
        field: 'name',
      },
      {
        id: 'selected_location_name',
        numeric: false,
        disablePadding: false,
        label: t('Users.PreferredLocation'),
        field: 'selected_location_name',
      },
      {
        id: 'email',
        numeric: false,
        disablePadding: false,
        label: t('Users.Email'),
        field: 'email',
      },
      {
        id: 'phone',
        numeric: false,
        disablePadding: false,
        label: t('Users.Phone'),
        field: 'phone',
      },
      {
        id: 'roles',
        numeric: false,
        disablePadding: false,
        label: t('Users.Roles'),
        field: 'roles',
      },
      {
        id: 'last_login_on',
        numeric: false,
        disablePadding: false,
        label: t('Users.LastLogin'),
        field: 'last_login_on',
      },
      {
        id: 'group_id',
        numeric: false,
        disablePadding: false,
        label: t('Groups.Dialog.Title'),
        field: 'group_id',
      },
      {
        id: 'is_enabled',
        numeric: false,
        disablePadding: false,
        label: t('Users.Status'),
        field: 'is_enabled',
      },
      {
        id: 'user_type',
        numeric: false,
        disablePadding: false,
        label: t('Users.UserType'),
        field: 'is_guest_user',
      },
      {
        id: 'actions',
        numeric: false,
        disablePadding: false,
        label: t('Users.Actions'),
      },
    ];
    return (
      <TableHead sx={{ height: '56px' }}>
        <TableRow>
          <TableCell sx={{ padding: '0 12px' }}>
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
              sx={{
                '&.Mui-checked': { color: '#0ae' },
                '&.MuiCheckbox-indeterminate': { color: '#0ae' },
              }}
            />
          </TableCell>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={'none'}
                sortDirection={orderBy === row.id ? order : false}
                sx={{
                  color: 'rgba(0, 0, 0, 0.54)',
                  fontSize: '0.75rem',
                  fontWeight: '500',
                }}
              >
                {['avatar', 'parent_account', 'roles', 'actions', 'selected_location_name', 'group_id'].includes(
                  row.id
                ) ? (
                  <TableSortLabel sx={{ '.MuiSvgIcon-root': { fontSize: 16 } }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t('Global.Label.Filter.Sort')}
                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                      sx={{ '.MuiSvgIcon-root': { fontSize: 16 }, minWidth: 'max-content' }}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const toolbarStyles = (theme) => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.mode === 'light'
      ? {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      }
      : {
        color: '#4fc3f7',
        backgroundColor: 'rgb(255, 234, 231)',
      },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
  },
  title: {
    flex: '0 0 auto',
  },
  add: {
    //backgroundColor: theme.palette.secondary.main,
    backgroundColor: '#00a7e1',
    color: '#fff',
    transition: 'background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    '&:hover': {
      backgroundColor: '#6cca98',
      color: '#fff',
    },
  },
  gridActions: {
    display: 'inline-block',
    width: '144px',
  },
});

let EnhancedTableToolbar = (props) => {
  const {
    numSelected,
    classes,
    add,
    confirmDelete,
    uadd,
    udelete,
    t,
    exportCSV, 
    userTypeEl,
    handleUserTypeDropDown,
    addGuestUser,
    handleDropDownClose, 
    addInstaller
  } = props;
  const openUserTypeDropDown = Boolean(userTypeEl);
  const isIlocalUser = localStorage.getItem('isIlocalUser');
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color='' variant='subheading'>
            {numSelected} {t('Users.SelectedRowsCount')}
          </Typography>
        ) : null}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected === 1 ? (
          <div>
            {udelete === true ? (
              <Tooltip
                key='single-delete'
                title={t('Users.DeleteUsersTooltip')}
              >
                <IconButton
                  aria-label='Delete'
                  onClick={confirmDelete}
                  sx={() => ({
                    '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                  })}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            ) : (
              ''
            )}
          </div>
        ) : numSelected > 1 ? (
          udelete === true ? (
            <Tooltip key='multi-delete' title={t('Users.DeleteUsersTooltip')}>
              <IconButton
                aria-label='Delete'
                onClick={confirmDelete}
                sx={() => ({
                  '&:hover': { backgroundColor: '#6cca98', color: '#fff' },
                })}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ) : (
            ''
          )
        ) : uadd === true ? (
          <div style={{ display: "flex", flexDirection: "row" }}>
            <Tooltip key="single-edit" title={t("Report.Assign.ExportCSVTooltip")}>
              <IconButton
                style={{ marginRight: '0' }}
                aria-label="ExportCSV"
                onClick={exportCSV}
              // disabled={this.state.isButtonDisabled}
              >
                <img alt="download" src={download} style={{ height: '25px', width: '25px', cursor: 'pointer' }} />
              </IconButton>
            </Tooltip>
            <Tooltip key='single-add' title={t('Users.AddUsersTooltip')}>
              <IconButton
                aria-label='Add User'
                aria-controls={openUserTypeDropDown ? 'dropdown-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={openUserTypeDropDown ? 'true' : undefined}
                className={classes.add} 
                onClick={handleUserTypeDropDown}
              >
                <AddUserIcon />
              </IconButton>
            </Tooltip>
              <Menu
                  id="dropdown-menu"
                  anchorEl={userTypeEl}
                  open={openUserTypeDropDown}
                  onClose={handleDropDownClose}
              >
                  <MenuItem onClick={add}>{t('Users.AddUser')}</MenuItem>
                  <MenuItem onClick={addGuestUser}>{t('Users.AddGuestUser')}</MenuItem>
                  {[true, 'true'].includes(isIlocalUser) &&
                    <MenuItem onClick={addInstaller}>
                      {t('Users.AddInstaller')}
                    </MenuItem>
                  }
                </Menu> 
          </div>
        ) : (
          ''
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(
  withTranslation()(EnhancedTableToolbar)
);

const styles = (theme) => ({
  Paper: {
    minWidth: '985px',
  },
  root: {
    width: '100%',
  },
  table: {
    minWidth: 'auto',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  halfTextField: {
    marginRight: '20px',
  },
  dropbox: {
    width: '135px',
    height: '105px',
    float: 'right',
    textAlign: 'center',
    boxShadow:
      '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
    overflow: 'hidden',
    top: '56px',
    right: '2px',
    position: 'relative',
  },
  innerBox: {
    margin: '0 auto',
    display: 'block',
    height: '100%',
  },
  dropImage: {
    width: '80%',
    height: '100%',
  },
  dropPic: {
    width: '100%',
    height: '100%',
  },
  errorDiv: {
    paddingTop: '10px',
    color: 'red',
  },
  captionText: {
    lineHeight: '1',
    color: '#8a8a8a',
    fontSize: '13px',
    textAlign: 'center',
  },
  twoChildren: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  leftChild: {},
  rightChild: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
  formControl: {
    margin: '5px',
    minWidth: '100%',
  },
  boxDesign: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  primaryButton: {
    background: '#6cca98',
    color: '#fff',
    '&:hover': {
      background: '#6cca98',
      color: '#fff',
    },
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.38)',
      cursor: 'not-allowed',
      background: '#E4E5E8',
    },
  },
  dialogTitle: {
    fontSize: '1.3125rem',
    fontWeight: 500,
    lineHeight: '1.16667em',
  },
  menuItem: {
    paddingTop: '10px',
    paddingBottom: '10px',
  },
});

const TextMaskCustom = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask='(#00) 000-0000'
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskCustom.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

let imgFile;
const ITEM_ROLE_HEIGHT = 48;
const ITEM_ROLE_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_ROLE_HEIGHT * 4.5 + ITEM_ROLE_PADDING_TOP,
      width: 250,
    },
  },
};

let FilterObj = {
  searchtext: '',
  searchObject: null,
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'created_on',
  tableName: '',
};

const UserSortObj = {
  name: { tableName: 'users', sortColumn: 'name' },
  username: { tableName: 'users', sortColumn: 'username' },
  email: { tableName: 'contacts', sortColumn: 'email' },
  phone: { tableName: 'contacts', sortColumn: 'phone' },
  last_login_on: { tableName: 'users', sortColumn: 'last_login_on' },
  is_enabled: { tableName: 'users', sortColumn: 'is_enabled' },
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;
const formattedDate = moment().tz(timeZone).format('MM/DD/YYYY');

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      orderBy: 'created_on',
      selected: [],
      page: 0,
      rowsPerPage: 10,
      submitted: false,
      isButtonDisabled: false,
      userview: true,
      useradd: true,
      userdelete: true,
      useredit: true,
      user: {
        first_name: '',
        last_name: '',
        badge_id: '',
        email: '',
        phone: '',
        roles: [],
      },
      searchtext: '',
      loader: false,
      disabledText: 'Disable',
      chipstores: [],
      chipboxes: [],
      isDisabled: false,
      selectedTab: 0,
      workDayStarts: new Date(),
      workDayEnds: new Date(),
      defaultReminder: false,
      sunday: false,
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      emailNotify: false,
      smsNotify: false,
      pushNotify: false,
      isOpenReminderSelect: false,
      reminderSelectID: '5m',
      innerLoader: false,
      isDisabledScheduleButton: false,
      rowID: null,
      isSuperAdmin: false,
      isAdmin: false,
      totalRecords: 0,
      preferredLanguage: [
        { id: 'en', label: this.props.t('Global.Language.English') },
        { id: 'fr', label: this.props.t('Global.Language.French') },
      ],
      preferLanguage: 'en',
      loadState: 0,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      authenticateUnlockUserDialogConfirmation: false,
      selectedUserEmailToAuthenticat: '',
      boxList: [],
      selectedBoxId: '',
      selectedLocationTypeId: '',
      selected_location_name: '',
      userdisabled: true,
      userresetpassword: true,
      userunlockuser: true,
      guestusersecurebadgeprint: false,
      guestusersecurebadgedownload: false,
      guestusersecurebadgeemail: false,
      groups: [],
      groupId: "",
      filteredGroup:[],
      accountsList: [],
      rolesError: null,
      showGuestUserDialog: false,
      secureBadgeAction: 'print',
      userMenuOpen: false, 
      userTypeEl: null,
      guestFormData: {
        firstName: '', 
        lastName: '',  
        email: '',
        nextEmail: '',
        nextEmailError: '',
        guestFirstNameError: null,
        guestLastNameError: null,
        guestEmailError: null,
        rolesError: null,
        parentAccountId: null,
        location: null,
        emailExistsUser: false,
        roles: [],
        userId: '',
        userEmail: '',
      }, 
      guestQrCodeImg: null,
      secureBadgeExpiry: null,
      isConfirmButtonDisabled: false,
      printGuestSecureBadgeQR: false,
      dialogEmailAlreadyExistsForGuest: false,
      userConfirmationForGuestUserSSWithExistingEmail: null,
      activeStep: 0,
      contextMenuUsed: null,
      showInstallerDialog: false,
      installerUserDetails:{
        firstName: '',
        lastName: '',
      },
      printInstallerSecureBadge:false,
      installerSecureBadgeQR:'',
      selectedAccountBoxList:[],
      currentContextUsername: '',
      openedEditFromAccount: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGuestFormUserAction = this.handleGuestFormUserAction.bind(this);
    this.handleGuestFormDataChange = this.handleGuestFormDataChange.bind(this);
    this.handleGuestFormSubmit = this.handleGuestFormSubmit.bind(this);
    this.handleConfirmAction = this.handleConfirmAction.bind(this);
    this.handleInstallerFormSubmit = this.handleInstallerFormSubmit.bind(this);
    this._prevPathname = '';
  }
 

  openUserPopup = async () => {
    // eslint-disable-next-line no-restricted-globals
    let params = location.pathname.includes('/users');
    if (params) {
      // eslint-disable-next-line no-restricted-globals, no-unused-expressions
      let type = location.pathname.split('/users')[1];
      type = type.replace(/\D/g, '');
      if ((type === 1 || type === '1') && this.state.loadState === 0) {
        let selectedObject;
        let loggedinUserName = JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.payload.email;
        const FilterObj = {
          searchtext: loggedinUserName,
          pageNo: 0,
          pageSize: 10,
          sortOrder: 'desc',
          sortColumn: 'created_on',
          tableName: '',
        };
        this.setState({ loader: true });
        await fetch(process.env.REACT_APP_BASEURL + 'getusers', {
          method: 'post',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                .jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(FilterObj),
        })
          .then((response) => {
            try {
              return response.json();
            } catch (error) {
              return null;
            }
          })
          .then((data) => {
            if (data && data.results && data.results.length > 0) {
              selectedObject = data.results[0]
            }
            this.setState({ loader: false });
          });
        if (![undefined, 'undefined', null, 'null', ''].includes(selectedObject)) {
          this.setState({
            loadState: 1,
            selectedTab: 0,
            showNewUserDialog: true,
            operation: 'Edit',
            rolesError: null,
            user: selectedObject,
            parent_account_id: selectedObject.parent_account_id,
            first_name: selectedObject.first_name,
            last_name: selectedObject.last_name,
            badge_id: selectedObject.badge_id,
            email: selectedObject.email || selectedObject.contact.email,
            avatarPreview: selectedObject.picture_url,
            phone: selectedObject.phone || selectedObject.contact.phone,
            roles: selectedObject.roles,
            rowID: selectedObject && selectedObject.id,
            parentID: selectedObject && selectedObject.parent_account_id,
            workDayStarts:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.work_day_starts,
            workDayEnds:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.work_day_ends,
            reminderSelectID:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.reminder,
            defaultReminder:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_default_reminder,
            sunday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_sunday,
            monday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_monday,
            tuesday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_tuesday,
            wednesday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_wednesday,
            thursday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_thursday,
            friday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_friday,
            saturday:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_saturday,
            emailNotify:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_email,
            smsNotify:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_sms,
            pushNotify:
              selectedObject &&
              selectedObject.scheduleCalendar &&
              selectedObject.scheduleCalendar.is_push,
            preferLanguage: selectedObject && selectedObject.preferred_language,
          });
        }
      }
    }
  };

  componentDidMount() {
    this._prevPathname = typeof window !== 'undefined' && window.location ? window.location.pathname : '';
    FilterObj.searchtext = '';
    this.setState({
      isSuperAdmin:
        sessionStorage.hasOwnProperty('superadmin') &&
        JSON.parse(sessionStorage.getItem('superadmin')) ===
        USER_ROLES.SUPERADMIN,
      isAdmin:
        sessionStorage.hasOwnProperty('admin') &&
        JSON.parse(sessionStorage.getItem('admin')) === USER_ROLES.ADMIN,
    });
    FilterObj.groupTypeId = ![undefined, "undefined", null, "null", ''].includes(sessionStorage.getItem('groupType')) ? sessionStorage.getItem('groupType') : null

    this.getLocationsByAccount();
    this.setPermissions();
    this.openEditFromAccountDeepLink();
    fetch(process.env.REACT_APP_BASEURL + 'roles', {
      method: 'GET',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => response.json())
      .then((roleLookupValues) => {
        if (roleLookupValues && roleLookupValues.length > 0) {
          const filtered = roleLookupValues.filter(
            r => ![ROLES_TYPE.RetailAdmin, ROLES_TYPE.RetailTechnician].includes(r.id)
          );
          this.setState({ roleLookupValues: [true, 'true'].includes(this.state.isSuperAdmin) ? roleLookupValues : filtered });
        }
      });

    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const accountValues = accounts.map((account) => {
          return {
            value: account.id,
            label: account.name,
            account_lineage: account.account_lineage,
          };
        });
        this.setState({
          accountsList: accounts,
          accountValues,
          parent_account_id: accountValues[0].value
        });

        this.fetchBadgeDuration(this.state.parent_account_id);
      });

    this.fetchSuggestions(); 

    ValidatorForm.addValidationRule('isValidEmail', async (value) => {
      const email = value;
      if(!value) return true; // return true if value is not provided.

      const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if((email.trim().length > 3) && (pattern).test(email)) {

          try{
            let result = await this.checkEmailExists(email); 

            if(Boolean(result.value)){ // true if email already exists in the database
                
                // setting state for popup 
                this.setState({
                  guestFormData : {
                    ...this.state.guestFormData,
                    emailExistsUser: Boolean(result.value)
                  }
                })
                return true;
          
            } else { // false if email does not exists in the database
                return true;
            }
          }catch(error){
              console.error('Error checking email availability:', error);
              return true; // Assume email exists if the API fails
          }

 
        }else{
          this.setState({
            guestFormData : {
              ...this.state.guestFormData,
              emailExistsUser: false
            }
          })
          return false;
        }
    }); 

    ValidatorForm.addValidationRule('nextEmailalreadyExists', async (value) => {
      const email = value;
      if(!value) return true; // return true if value is not provided.

      try{
        let result = await this.checkEmailExists(email);
        if(Boolean(result.value)){ // true if email already exists in the database
            this.setState({
              guestFormData : {
                ...this.state.guestFormData,
                nextEmailError: true
              }
            })
            return false;          
        } else { // false if email does not exists in the database
            this.setState({
              guestFormData : {
                ...this.state.guestFormData,
                nextEmailError: false
              }
            })
            return true;
        }
      }catch(error){
          console.error('Error checking email availability:', error);
          return true; // Assume email exists if the API fails
      } 
          
    });    

  };

  checkEmailExists = async (email) => {
        let response = await fetch(
        process.env.REACT_APP_BASEURL +
        'checkemailexist/' +
        email,
        {
          method: 'GET',
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
          },
        }
        )
        const result = await response.json(); // true if email already exists in the database
        return result;
  }

  guestUserEmailAlreadyExistsNoBtn = (e) => {
    this.setState({
      userConfirmationForGuestUserSSWithExistingEmail : false,
      dialogEmailAlreadyExistsForGuest: false,
      showNewUserDialog: false, 
      user: {}, 
      errorMessage: '', 
      showGuestUserDialog: false,  
      activeStep: 0, 
      guestQrCodeImg: null, 
      printGuestSecureBadgeQR: false,
      guestFormData: {},
      loader: false,
      chipstores: [],
      selectedBoxId: '',
    });
  };

  guestUserEmailAlreadyExistsYesBtn = (e) => {
    this.setState({
      userConfirmationForGuestUserSSWithExistingEmail : true,
      dialogEmailAlreadyExistsForGuest: false,
      guestFormData: {
        ...this.state.guestFormData, 
      }
    }); 
    // submit the guest registration form
    this.handleGuestFormSubmit(e);
  };

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en'
      ? date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('MM/DD/YYYY hh:mm:ss A')
      : date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('DD/MM/YYYY hh:mm:ss A');
  };

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === 'function') {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === 'function') {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: FilterObj,
      applyFilterModel: (body, filterModel) => {
        body.searchtext = foldFiltersToSearchText(filterModel);
        body.searchObject =
          filterModel && Object.keys(filterModel).length ? filterModel : null;
      },
      sortMap: UserSortObj,
      pageZeroBased: true,
      getPageSize: () => FilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + 'getusers', {
          method: 'post',
          withCredentials: true,
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body),
        }).then((r) => r.json()),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
          selected: [],
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    if (typeof params.api.setServerSideDatasource === 'function') {
      params.api.setServerSideDatasource(datasource);
    }
  };

  onRowSelected = (params) => {
    if (!params || !params.api) return;
    const selectedNodes = params.api.getSelectedNodes() || [];
    this.setState({
      selected: selectedNodes.map((n) => n.data && n.data.id).filter(Boolean),
    });
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && FilterObj.pageSize !== newPageSize) {
      FilterObj.pageSize = newPageSize;
    }
  };

  BindBoxes() {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'getusers', {
      method: 'post',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(FilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        this.setState({ totalRecords: data && data.total });
        if (data && data.results && data.results.length > 0) {
          this.setState(
            { data: data.results, loader: false, isDataEmpty: false },
            () => {
              this.openUserPopup();
            }
          );
        } else {
          this.setState({ data: null, loader: false, isDataEmpty: true });
        }
      });
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (
      [
        'name',
        'username',
        'dob',
        'status',
        'is_enabled',
        'last_login_on',
      ].includes(field)
    ) {
      tablename = 'users';
    }
    if (['email', 'phone'].includes(field)) {
      tablename = 'contacts';
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ order, orderBy, sortId: property });
    FilterObj.sortOrder = order;
    FilterObj.sortColumn = field;
    FilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      this.setState((state) => ({ selected: state.data.map((n) => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const {selected} = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    event && event.preventDefault();
    
    FilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  handleChangeRowsPerPage = (event) => {
    
    FilterObj.pageNo = 0;
    FilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindBoxes();
    }
  };

  addUser = (event) => {
    const parentAccountId = this.state.parent_account_id;
    const deps = this.applyParentAccountDependencies(parentAccountId, {
      preferredTypeId: sessionStorage.getItem('groupType'),
      forceDefaultLocation: true,
    });
    this.setState({
      groupId: deps.groupId,
      filteredGroup: deps.filteredGroup,
      selectedAccountBoxList: deps.filteredBoxList,
      selectedBoxId: deps.selectedBoxId,
      selectedLocationTypeId: deps.selectedLocationTypeId,
      selected_location_name: deps.selected_location_name,
      showNewUserDialog: true,
      user: {},
      operation: 'Add',
      first_name: '',
      last_name: '',
      badge_id: '',
      email: '',
      avatarPreview: null,
      phone: null,
      roles: null,
      rolesError: null,
      disabledText: 'Disable',
      selectedTab: 0,
    });
  };

  addGuestUser = (e) => {
    const parentAccountId = this.state.parent_account_id;
    const deps = this.applyParentAccountDependencies(parentAccountId, {
      preferredTypeId: sessionStorage.getItem('groupType'),
      forceDefaultLocation: true,
    });
    this.setState({
      groupId: deps.groupId,
      filteredGroup: deps.filteredGroup,
      selectedAccountBoxList: deps.filteredBoxList,
      selectedBoxId: deps.selectedBoxId,
      selectedLocationTypeId: deps.selectedLocationTypeId,
      selected_location_name: deps.selected_location_name,
      showGuestUserDialog: true,
      user: {},
      operation: 'AddGuest',
      first_name: '',
      last_name: '',
      badge_id: '',
      email: '',
      avatarPreview: null,
      phone: null,
      roles: null,
      rolesError: null,
      guestFormData: { ...this.state.guestFormData, rolesError: null },
      disabledText: 'Disable',
      selectedTab: 0,
    });
  };

  addInstaller = (e) => {
    const superAdminRole = this.state.roleLookupValues.find((role) => role.id === userroles.ADMIN);

    const filteredList = this.state.boxList.filter((box) => box.parent_account_id === this.state.accountValues[0].value);
    const filteredBoxList = filteredList.length > 0 ? filteredList : this.state.boxList

    this.setState({
      groupId: "",
      showInstallerDialog: true,
      selectedAccountBoxList: filteredBoxList,
      parent_account_id: this.state.accountValues[0].value,
      selectedBoxId: filteredBoxList[0].id,
      selectedLocationTypeId: filteredBoxList[0].locationtype_id,
      selected_location_name:filteredBoxList[0].value,
      installerUserDetails: {
        ...this.state.installerUserDetails,
        lastName: filteredBoxList[0].value,
        firstName: this.state.accountValues[0].label,
      },
      chipstores: superAdminRole ? [superAdminRole] : [],
      roles: superAdminRole ? [superAdminRole] : [],
    });
  };

  handleUserTypeDropDown = e => { 
    this.setState({
      userTypeEl: e.currentTarget
    })
  };

  handleDropDownClose = (e) => { 
    this.setState({
      userTypeEl: null
    })
  };

  handleGuestFormUserAction = (e) => {
    this.setState({
      secureBadgeAction: e.target.value
    }) 
  }; 

  handleGuestFormDataChange = async (e) => {
    let {name, value} = e.target, obj = {};
    value = value.trim(); 

    if(name === 'firstName' && value === '') {
      obj.guestFirstNameError = true
    }else{
      obj.guestFirstNameError = false
    }

    if(name === 'lastName' && value === '') {
      obj.guestLastNameError = true
    }else{
      obj.guestLastNameError = false
    } 

    this.setState({
      guestFormData: {
        ...this.state.guestFormData,
        [name]: value,
        ...obj,
      }
    });
  };

  handleGuestFormValidation = () => {
    const {firstName, lastName} = this.state.guestFormData;
    const {t} = this.props;
    let valid = true;
    const updates = { guestFormData: { ...this.state.guestFormData } };
    if ((firstName.trim().length === 0) || (lastName.trim().length === 0)) {
      valid = false;
    }
    if (!this.state.roles || this.state.roles.length === 0) {
      valid = false;
      updates.guestFormData.rolesError = t('Validation.SelectAtLeastOneRole');
    } else {
      updates.guestFormData.rolesError = null;
    }
    if (!valid && (firstName.trim().length > 0 && lastName.trim().length > 0)) {
      this.setState(updates);
    } else if (!valid) {
      this.setState(updates);
    }
    return valid;
  }

  createGuestSecureBadge = (user) => {

      fetch(process.env.REACT_APP_BASEURL + "generateSecureBadgeForGuestUser", {
        method: "post",
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(user)
      })
        .then((response) => response.text())
        .then((res) => {
          res = JSON.parse(res); 
          /* to update users list and get updated secure badge and other important data. */
          this.BindBoxes();

          /* generate audit log of secure badge */
          writeAuditLog(`Secure badge created for '${!([null, undefined, ''].includes(user.username)) ? user.username : user.first_name + " " + user.last_name}'.`, 'Guest User');

          this.setState({
            guestQrCodeImg: res.secureBadge, 
            errorMessage: "",
            loader: false, 
            groupId: '',
            chipstores: [],
          });
          
          res.secureBadge
            ? toast.success(res.message, { className: "topAlignment" })
            : toast.error(res.message, { className: "topAlignment" });
        })
        .catch((reason) => {
          toast.error(reason.message);
          this.setState({
            loader: false, 
            errorMessage: reason.message,
          });
        });

  
  };

  handleGuestFormSubmit = (e) => {
         
    this.setState({
      loader: true,
      isButtonDisabled: true,
      isConfirmButtonDisabled: false,
      dialogEmailAlreadyExistsForGuest: false,
    });  

    // validate form data (requires at least one role)
    const validate = this.handleGuestFormValidation(); 

    if (!validate) {
      this.setState({ loader: false, isButtonDisabled: false });
      if (!this.state.roles || this.state.roles.length === 0) {
        toast.error(this.props.t('Validation.SelectAtLeastOneRole'));
      }
      return;
    }

    if (!this.validateUserFormDefaults()) {
      this.setState({ loader: false, isButtonDisabled: false });
      return;
    }

    if(validate){
      const Obj = {};
      let _selectedLocation = [];
      const {boxList, selectedBoxId} = this.state;
      if([null, undefined, 'undefined', ''].includes(selectedBoxId)){
        _selectedLocation = boxList[0];  
      }else{
        _selectedLocation = boxList.find((x) =>
          this.idsEqual(x.id, this.state.selectedBoxId)
        );    
      } 

      Obj.parent_account_id = this.state.parent_account_id;
      Obj.firstName = this.state.guestFormData.firstName;
      Obj.lastName = this.state.guestFormData.lastName;
      Obj.email = (this.state.guestFormData.email)?this.state.guestFormData.email:'';
      Obj.selected_location_id =  (Boolean(selectedBoxId))?selectedBoxId:_selectedLocation.id;
      Obj.selected_location_type_id = _selectedLocation.locationtype_id;
      Obj.selected_location_name = _selectedLocation.value;
      Obj.group_id = this.state.groupId;

      if (this.state.roles && this.state.roles.length > 0) {
        Obj.roles = this.state.roles.map((x) => x.id);
      }

      const result = fetch(process.env.REACT_APP_BASEURL + 'guestUser', {
                      method: 'POST',
                      withCredentials: true,
                      headers: {
                        Authorization:
                          'Bearer ' +
                          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                            .jwtToken,
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(Obj),
                    });

            result
            .then((result) => result.json())
            .then((res) => { 

                  if (res.error || res.message) {
                    this.setState({
                      loader: false,
                      isButtonDisabled: false,
                      submitted: false,
                    });
                    if (res.success === false) {
                      toast.error(res.message);
                    } else {
                      toast.error(
                        this.props.t('Toast.Error.AdministratorContact')
                      );
                    }
                  } else {
                    // generate secure badge for the guest user
                    // const userObj = {
                    //   id : res.user.id,
                    //   email : res.user.username,
                    //   user: res.user
                    // }
                    writeAuditLog(`Guest user created '${!([null, undefined, ''].includes(res.user.username)) ? res.user.username : res.user.first_name + " " + res.user.last_name}' by user.`, 'Guest User');
                    this.createGuestSecureBadge(res.user);
                    this.setState({
                      isButtonDisabled: false,
                      isConfirmButtonDisabled: false,
                      user: {}, 
                      errorMessage: '', 
                      userConfirmationForGuestUserSSWithExistingEmail: null,
                      userTypeEl: null,
                      activeStep: 1,
                      guestFormData: {
                        ...this.state.guestFormData,
                        userId: res.user.id,
                        userEmail: res.user.username,
                      }
                    });                        
                  }
            })            
            .catch((error) => {
              this.setState({ loader: false, errorMessage: error.message, isButtonDisabled: false, isConfirmButtonDisabled: true, });
            }); 

    }else{
      this.setState({
        loader: false, 
        errorMessage: 'Fill all fields', 
        isButtonDisabled: false, 
        isConfirmButtonDisabled: false, 
      }); 
    }

  };

  handleConfirmAction = (e) => {

    const {secureBadgeAction, guestQrCodeImg, guestFormData} = this.state;

    if(secureBadgeAction === 'print'){

              this.setState({
                printGuestSecureBadgeQR : true
              })
              setTimeout(() => {
                window.print();
                this.setState({
                  printGuestSecureBadgeQR: false,   
                  loader: false,  
                  errorMessage: '', 
                  showGuestUserDialog: false, 
                  dialogEmailAlreadyExistsForGuest: false, 
                  activeStep: 0,  
                  secureBadgeAction: 'print', 
                  guestFormData: {},
                  selectedBoxId: '',
                  guestQrCodeImg: null                  
                });
              }, 1200);

    }else if(secureBadgeAction === 'download'){
      
              try {
                // get content from the s3 bucket 
                const Obj = {
                  url : this.state.guestQrCodeImg
                };
                fetch(process.env.REACT_APP_BASEURL + 'downloadSecureBadge', {
                  method: 'post',
                  withCredentials: true,
                  headers: {
                    'Content-Type': 'application/json',
                    Authorization:
                      'Bearer ' +
                      JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                        .jwtToken,
                  },
                  body: JSON.stringify(Obj),
                })
                .then((response) => response.json())
                .then(res => {
                    const link = document.createElement('a');
                    link.href = res.url;            
                    link.target = "_Blank";
                    link.download = "secure_badge.png"
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
      
                    this.setState({
                      loader: false,  
                      errorMessage: '',
                      secureBadgeAction: 'print', 
                      showGuestUserDialog: false, 
                      dialogEmailAlreadyExistsForGuest: false, 
                      activeStep: 0,  
                      printGuestSecureBadgeQR: false,
                      guestFormData: {},
                      selectedBoxId: '',
                      guestQrCodeImg: null
                    });
                    res.success ? toast.success(res.message, { className: 'topAlignment'}) : toast.error(res.message, { className: 'topAlignment'});   
                })
                .catch(error => {
                  console.error(`Error during fetching secure badge file content : ${error}`);
                });
              } catch (error) {
                console.error('Error generating URL:', error);
              }

    }else if(secureBadgeAction === 'email'){

              const Obj = {
                file : guestQrCodeImg,
                user : guestFormData
              }; 
              const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
              
              // check if email is provided in the step 2
              // if provided then use that email to send secure badge to the user
              const {email} = this.state.guestFormData;  
              if( ['undefined', undefined, null, ''].includes(email) ){ // if email is empty

                  toast.error('Please enter email address', { className: 'topAlignment'});
                  this.setState({
                    loader: false,  
                    errorMessage: 'Please enter email address',
                  });

              } else if(!pattern.test(email)) { // if email is not valid

                  toast.error('Please enter valid email address', { className: 'topAlignment'});
                  this.setState({
                    loader: false,
                    errorMessage: 'Please enter valid email address',
                  });

              } else if(!['undefined', undefined, null, ''].includes(email)){ // email is not empty

                  fetch(process.env.REACT_APP_BASEURL + 'emailGuestSecureBadge', {
                    method: 'post',
                    withCredentials: true,
                    headers: {
                      'Content-Type': 'application/json',
                      Authorization:
                        'Bearer ' +
                        JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
                          .jwtToken,
                    },
                    body: JSON.stringify(Obj),
                  })
                  .then(res => res.json())
                  .then((response) => {
                    this.setState({ 
                      loader: false, 
                      errorMessage: '',
                      secureBadgeAction: 'print', 
                      showGuestUserDialog: false, 
                      dialogEmailAlreadyExistsForGuest: false, 
                      activeStep: 0,  
                      printGuestSecureBadgeQR: false,
                      guestFormData: {},
                      selectedBoxId: '',
                      guestQrCodeImg: null,
                      /* removing context menu */
                      anchorEl: null, 
                      selectedRowId: null, 
                      contextMenuUsed: null
                      /* removing context menu */
                    });
                    response.success ? toast.success(response.message, { className: 'topAlignment'}) : toast.error(response.message, { className: 'topAlignment'});        
                  })       
                  .catch((error) => {
                    toast.error(error.message);
                    this.setState({
                      loader: false,  
                      errorMessage: error.message,
                    });
                  })                 

              } 

    }else{
      this.setState({ loader: false, errorMessage: "Invalid request" }); 
    }

  };

  deleteUsers = (event) => {
    this.setState({ loader: true });
    const result = fetch(
      process.env.REACT_APP_BASEURL +
      'users/' +
      this.state.selected.join(',').trim(','),
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      const newData = [];
      this.state.data.forEach((item) => {
        if (this.state.selected.indexOf(item.id) === -1) {
          newData.push(item);
        }
      });
      let deletedUserList = this.state.selected.join(',').trim(',');
      /* generate audit log of secure badge */
      writeAuditLog(`'${deletedUserList}' user(s) are deleted by user.`, 'Manage User');

      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
      });
    });
  };

  handleClose = (event) => {
    const pathname = typeof window !== 'undefined' && window.location ? window.location.pathname : '';
    const isPreferencesRoute = pathname.endsWith('/users/1');
    this.setState({
      showNewUserDialog: false,
      user: {},
      guestFormData: {},
      errorMessage: '',
      showGuestUserDialog: false,
      dialogEmailAlreadyExistsForGuest: false,
      activeStep: 0,
      printGuestSecureBadgeQR: false,
      secureBadgeAction: 'print',
      selectedBoxId: '',
      chipstores: [],
      guestQrCodeImg: null,
      /* removing context menu */
      anchorEl: null,
      selectedRowId: null,
      contextMenuUsed: null,
      showInstallerDialog: false,
      /* removing context menu */
      currentContextUsername: '',
      // Reset loadState when closing preferences modal so Preferences can reopen it
      ...(isPreferencesRoute ? { loadState: 0 } : {}),
    });
  };

  handleDrop = (acceptedFiles, rejectedFiles) => {
    console.dir(acceptedFiles);
    this.setState({
      avatarPreview: acceptedFiles[0].preview,
      file: acceptedFiles,
    });
  };

  isvalidEmail(email) {
    console.log('this.state.email', this.state.email);
    const trulyValue = email === this.state.email;
    if (!trulyValue) {
      return false;
    }
    return trulyValue;
  }

  checkEmail = (event) => {
    this.setState({ loader: true });
    const searchedString = event.target.value;
    this.setState({ email: searchedString });
    if (searchedString.length > 0) {
      let isvalid = this.isvalidEmail(searchedString);
      if (isvalid > 0) {
        fetch(
          process.env.REACT_APP_BASEURL +
          'checkemailexistornot/' +
          searchedString,
          {
            method: 'GET',
            withCredentials: true,
            headers: {
              'Content-Type': 'application/json',
              Authorization:
                'Bearer ' +
                JSON.parse(sessionStorage.getItem('user')).signInUserSession
                  .idToken.jwtToken,
            },
          }
        )
          .then((response) => response.json())
          .then((emailcheck) => {
            this.setState({ loader: false });
            if (emailcheck && emailcheck.email_Is_Exist) {
              toast.error(this.props.t('Toast.Error.Email'));
              this.setState({ email: '' });
            } else {
              this.setState({ emailcheck });
            }
          });
      } else this.setState({ loader: false });
    }
  };

  normalizeInput = (value, previousValue) => {
    if (!value) return value;
    const currentValue = value.replace(/[^\d]/g, "");
    const cvLength = currentValue.length;

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue;
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`;
    }
  };

  handleChange = (event) => {
    if (event.preventDefault) event.preventDefault();

    const {user} = this.state;
    const {
      target: { id, name, value },
    } = event;
    if (['email'].includes(name || id)) {
      user[name || id] = (value || '').toLowerCase();
    } else if (['phone'].includes(name || id)) {
      user[name || id] = this.normalizeInput(value)
    }
    else user[name || id] = value; 
    
    this.setState(user);
  };

  removeImg = () => {
    const parent = document.getElementById('avatardropzone');
    let imgSrc = ((parent.children && parent.children[0]).src = '');
    imgFile = new File([imgSrc], 'filename');
  };

  handleView = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    console.log('OBJ-------------- ', selectedObject)
    // Map user's roles to roleLookupValues objects to maintain object reference equality
    const mappedRoles = selectedObject.roles && selectedObject.roles.length > 0
      ? selectedObject.roles.map(role => 
          this.state.roleLookupValues.find(r => r.id === role.id) || role
        )
      : [];
    this.setState({ selectedTab: 0 });
    this.setState({
      showNewUserDialog: true,
      operation: "View",
      rolesError: null,
      user: selectedObject,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.first_name,
      last_name: selectedObject.last_name,
      badge_id: selectedObject.badge_id,
      email: selectedObject.email || selectedObject.contact.email,
      avatarPreview: selectedObject.picture_url,
      phone: selectedObject.phone || selectedObject.contact.phone,
      roles: mappedRoles,
      chipstores: mappedRoles,
      // -- Need to enable when we deployed appountments.
      rowID: selectedObject && selectedObject.id,
      parentID: selectedObject && selectedObject.parent_account_id,
      workDayStarts:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.work_day_starts,
      workDayEnds:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.work_day_ends,
      reminderSelectID:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.reminder,
      defaultReminder:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_default_reminder,
      sunday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sunday,
      monday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_monday,
      tuesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_tuesday,
      wednesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_wednesday,
      thursday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_thursday,
      friday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_friday,
      saturday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_saturday,
      emailNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_email,
      smsNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sms,
      pushNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_push,
      preferLanguage: selectedObject && selectedObject.preferred_language,
      selectedBoxId:
        selectedObject &&
        selectedObject.preferredLocation &&
        selectedObject.preferredLocation.selected_location_id
          ? selectedObject.preferredLocation.selected_location_id
          : '',
      groupId: selectedObject && selectedObject.group_id
    });
    this.refreshGroupsForModal(
      selectedObject.parent_account_id,
      selectedObject.group_id,
      selectedObject.preferredLocation &&
        selectedObject.preferredLocation.selected_location_id
    );
    this.handleContextClose(event);
  };

  handleEdit = (event) => {
    console.log('In Edit mode');
    console.log('this.state.data.', this.state.data);
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.applyEditFromUserObject(selectedObject);
    this.handleContextClose(event);
  };

  applyEditFromUserObject = (selectedObject) => {
    if (!selectedObject) {
      return;
    }
    const mappedRoles = selectedObject.roles && selectedObject.roles.length > 0
      ? selectedObject.roles.map(role =>
          (this.state.roleLookupValues || []).find(r => r.id === role.id) || role
        )
      : [];
    this.setState({ selectedTab: 0 });
    this.setState({
      showNewUserDialog: true,
      operation: 'Edit',
      rolesError: null,
      user: selectedObject,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.first_name,
      last_name: selectedObject.last_name,
      badge_id: selectedObject.badge_id,
      email: selectedObject.email || (selectedObject.contact && selectedObject.contact.email),
      avatarPreview: selectedObject.picture_url,
      phone: selectedObject.phone || (selectedObject.contact && selectedObject.contact.phone),
      roles: mappedRoles,
      chipstores: mappedRoles,
      rowID: selectedObject && selectedObject.id,
      parentID: selectedObject && selectedObject.parent_account_id,
      workDayStarts:
        selectedObject &&
          selectedObject.scheduleCalendar &&
          selectedObject.scheduleCalendar.work_day_starts &&
          selectedObject.scheduleCalendar.work_day_starts !== null &&
          selectedObject.scheduleCalendar.work_day_starts !== 'null' &&
          selectedObject.scheduleCalendar.work_day_starts !== undefined &&
          selectedObject.scheduleCalendar.work_day_starts !== 'undefined'
          ? selectedObject.scheduleCalendar.work_day_starts
          : new Date(),
      workDayEnds:
        selectedObject &&
          selectedObject.scheduleCalendar &&
          selectedObject.scheduleCalendar.work_day_ends &&
          selectedObject.scheduleCalendar.work_day_ends !== null &&
          selectedObject.scheduleCalendar.work_day_ends !== 'null' &&
          selectedObject.scheduleCalendar.work_day_ends !== undefined &&
          selectedObject.scheduleCalendar.work_day_ends !== 'undefined'
          ? selectedObject.scheduleCalendar.work_day_ends
          : new Date(),
      reminderSelectID:
        selectedObject &&
          selectedObject.scheduleCalendar &&
          selectedObject.scheduleCalendar.reminder &&
          selectedObject.scheduleCalendar.reminder !== null &&
          selectedObject.scheduleCalendar.reminder !== 'null' &&
          selectedObject.scheduleCalendar.reminder !== undefined &&
          selectedObject.scheduleCalendar.reminder !== 'undefined' &&
          selectedObject.scheduleCalendar.reminder !== ''
          ? selectedObject.scheduleCalendar.reminder
          : this.state.reminderSelectID,
      defaultReminder:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_default_reminder,
      sunday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sunday,
      monday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_monday,
      tuesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_tuesday,
      wednesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_wednesday,
      thursday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_thursday,
      friday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_friday,
      saturday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_saturday,
      emailNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_email,
      smsNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sms,
      pushNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_push,
      preferLanguage: selectedObject && selectedObject.preferred_language,
      selectedBoxId:
        selectedObject &&
        selectedObject.preferredLocation &&
        selectedObject.preferredLocation.selected_location_id
          ? selectedObject.preferredLocation.selected_location_id
          : '',
      editAuditBaselineSelectedBoxId:
        selectedObject &&
        selectedObject.preferredLocation &&
        selectedObject.preferredLocation.selected_location_id
          ? selectedObject.preferredLocation.selected_location_id
          : '',
      groupId: selectedObject && selectedObject.group_id
    });
    this.refreshGroupsForModal(
      selectedObject.parent_account_id,
      selectedObject.group_id,
      selectedObject.preferredLocation &&
        selectedObject.preferredLocation.selected_location_id
    );
  };

  getEditUserIdFromQuery = () => {
    if (typeof window === 'undefined' || !window.location) {
      return null;
    }
    try {
      return new URLSearchParams(window.location.search).get('editUserId');
    } catch (e) {
      return null;
    }
  };

  getAccountIdFromQuery = () => {
    if (typeof window === 'undefined' || !window.location) {
      return null;
    }
    try {
      return new URLSearchParams(window.location.search).get('accountId');
    } catch (e) {
      return null;
    }
  };

  clearEditFromAccountQuery = () => {
    navigate('/home/manage/users/0', { replace: true });
  };

  canModifyManageUsers = () => {
    try {
      const checkUserRole = sessionStorage.getItem('permissionUser');
      if (checkUserRole === USER_ROLES.SUPERADMIN) {
        return true;
      }
      const permissions = JSON.parse(sessionStorage.getItem('permissions') || '[]');
      const manageUsers = permissions.filter(
        (item) => item.permission_entity_type === 'Manage Users'
      );
      return manageUsers.some(
        (x) => x.name && x.name.trim() === 'Modify' && x.is_allowed === 1
      );
    } catch (e) {
      return false;
    }
  };

  openEditFromAccountDeepLink = async () => {
    const editUserId = this.getEditUserIdFromQuery();
    const accountId = this.getAccountIdFromQuery();
    if (!editUserId || this.state.openedEditFromAccount) {
      return;
    }

    this.setState({ openedEditFromAccount: true });

    if (!accountId) {
      this.clearEditFromAccountQuery();
      toast.error(this.props.t('Users.NoDataFound'));
      return;
    }

    if (!this.canModifyManageUsers()) {
      this.clearEditFromAccountQuery();
      toast.error(this.props.t('Accounts.ViewUsersDialog.NoEditPermission'));
      return;
    }

    let selectedObject = null;
    try {
      const groupType = sessionStorage.getItem('groupType');
      const groupTypeId = ![undefined, 'undefined', null, 'null', ''].includes(
        groupType
      )
        ? groupType
        : null;
      const response = await fetch(
        process.env.REACT_APP_BASEURL + 'accounts/users/by/account',
        {
          method: 'post',
          headers: {
            Authorization:
              'Bearer ' +
              JSON.parse(sessionStorage.getItem('user')).signInUserSession
                .idToken.jwtToken,
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            accountId,
            userId: editUserId,
            pageNo: 0,
            pageSize: 1,
            sortOrder: 'desc',
            sortColumn: 'created_on',
            searchtext: '',
            groupTypeId,
          }),
        }
      );
      const data = await response.json();
      if (data && data.results && data.results.length > 0) {
        selectedObject = data.results[0];
      }
    } catch (e) {
      selectedObject = null;
    }

    this.clearEditFromAccountQuery();

    if (!selectedObject || !selectedObject.id) {
      toast.error(this.props.t('Users.NoDataFound'));
      return;
    }

    this.applyEditFromUserObject(selectedObject);
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    } else {
      this.deleteUsers();
    }
    this.setState({ deleteDialogOpen: false });
    toast.success(this.props.t('Toast.Success.UserRemoved'));
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + 'users/' + rowIdToDelete,
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      const {currentContextUsername} = this.state;
      writeAuditLog(`'${(currentContextUsername !== '') ? currentContextUsername : 'User '}' is deleted by User.`, 'Manage Users');
      this.setState({ loader: false });
      this.handleContextClose(event);
      const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
        selectedRowId: null,
      });
      this.handleContextClose(event);
    });
  };

  handleSearchChange = (event) => {
    let searchtxt = '';
    searchtxt = event.target.value;
    this.setState({ searchtext: event.target.value });
    FilterObj.sortOrder = 'desc';
    FilterObj.sortColumn = 'created_on';
    FilterObj.tableName = '';
    if (searchtxt.length >= 3) {
      FilterObj.searchtext = searchtxt;
      this.BindBoxes();
    } else if (searchtxt.length === 0) {
      FilterObj.searchtext = '';
      this.BindBoxes();
    }
  };

  validateUserFormDefaults = () => {
    const filteredBoxes = this.getFilteredLocationsForParent(
      this.state.parent_account_id,
      this.state.boxList
    );
    if (
      filteredBoxes.length > 0 &&
      !filteredBoxes.some((box) => this.idsEqual(box.id, this.state.selectedBoxId))
    ) {
      toast.error('Preferred Location is required for the selected parent account.');
      return false;
    }

    if (this.loggedInUserHasGroup()) {
      const allowedAccountIds = this.getAccountIdsForParentTree(
        this.state.parent_account_id
      );
      const filteredGroups = (this.state.groups || []).filter((group) =>
        allowedAccountIds.some((id) =>
          this.idsEqual(group.parent_account_id, id)
        )
      );
      if (filteredGroups.length > 0 && this.isEmptyValue(this.state.groupId)) {
        toast.error(
          'Group is required for the selected parent account when the logged-in user belongs to a group.'
        );
        return false;
      }
    }
    return true;
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const {t} = this.props;
    if (!this.state.roles || this.state.roles.length === 0) {
      this.setState({ rolesError: t('Validation.SelectAtLeastOneRole'), isButtonDisabled: false });
      toast.error(t('Validation.SelectAtLeastOneRole'));
      return;
    }
    if (!this.validateUserFormDefaults()) {
      this.setState({ isButtonDisabled: false });
      return;
    }
    this.setState({
      loader: true,
      isButtonDisabled: true,
      rolesError: null,
    });
    var input = document.querySelector('input[type="file"]');
    var data = new FormData();
    const {boxList} = this.state;
    const _selectedLocation = boxList.find((x) =>
      this.idsEqual(x.id, this.state.selectedBoxId)
    );
    if (!_selectedLocation) {
      toast.error('Preferred Location is required for the selected parent account.');
      this.setState({ loader: false, isButtonDisabled: false });
      return;
    }
    data.append('file', input.files[0]);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('badge_id', this.state.badge_id);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('preferredlanguage', this.state.preferLanguage);
    data.append('selected_location_id', this.state.selectedBoxId);
    data.append('selected_location_type_id', _selectedLocation.locationtype_id);
    data.append('selected_location_name', _selectedLocation.value);
    data.append('group_id', this.state.groupId || null);
    if (this.state.roles && this.state.roles.length > 0) {
      data.append(
        'roles',
        this.state.roles.map((x) => x.id)
      );
    }

    const result = fetch(process.env.REACT_APP_BASEURL + 'users', {
      method: 'POST',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error || res.message) {
            this.setState({
              isButtonDisabled: false,
              submitted: false,

            });
            if (res.success === false) {
              toast.error(res.message);
            } else {
              toast.error(
                this.props.t('Toast.Error.AdministratorContact')
              );
            }
          } else {
            this.state.data.unshift(res.user);
            const newData = JSON.parse(JSON.stringify(this.state.data));
            writeAuditLog(`'${!([null, undefined, ''].includes(res.user.username)) ? res.user.username : res.user.first_name + " " + res.user.last_name}' user created.`, 'Manage User');
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              data: newData,
              searchtext: '',
            });
            let loggedInUser = sessionStorage.getItem('user');
            if(![undefined, 'undefined', null, 'null', ''].includes(loggedInUser)) {
              const parsedUser = JSON.parse(loggedInUser);
              if(parsedUser.username === res.user.id && res.preferredLocation) {
                localStorage.setItem('selectedLocation', res.preferredLocation.selected_location_id);
                localStorage.setItem('selectedLocationTypeId', res.preferredLocation.selected_location_type_id)
                localStorage.setItem('selected_location_name', res.preferredLocation.selected_location_name)
                // Notify Home header to re-read preferred location without requiring re-login
                window.dispatchEvent(new CustomEvent('preferredLocationChanged', {
                  detail: res.preferredLocation,
                }));
              }
            }
            toast.success(this.props.t('Toast.Success.UserAdded'));
            FilterObj.searchtext = '';
            FilterObj.sortOrder = 'desc';
            FilterObj.sortColumn = 'created_on';
            FilterObj.tableName = '';
            this.BindBoxes();
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message, isButtonDisabled: false });
      });
  };

  changeLanguage = () => {
    let loggedinUserID = JSON.parse(sessionStorage.getItem('user')).username;
    if (this.state.user.id !== loggedinUserID) {
      return true;
    }

    let preferLanguage = sessionStorage.getItem('preferredLanguage');
    if (this.state.preferLanguage !== preferLanguage) {
      sessionStorage.setItem('preferredLanguage', this.state.preferLanguage);
      const {i18n} = this.props;
      i18n.changeLanguage(this.state.preferLanguage);
    }
  };

  handleUpdate = (event) => {
    event.preventDefault();
    const {t} = this.props;
    if (!this.state.roles || this.state.roles.length === 0) {
      this.setState({ rolesError: t('Validation.SelectAtLeastOneRole'), isButtonDisabled: false });
      toast.error(t('Validation.SelectAtLeastOneRole'));
      return;
    }
    if (!this.validateUserFormDefaults()) {
      this.setState({ isButtonDisabled: false });
      return;
    }
    this.setState({
      loader: true,
      isButtonDisabled: true,
      rolesError: null,
    });
    var input = document.querySelector('input[type="file"]');
    var data = new FormData();
    if (
      input.files !== null &&
      input.files !== undefined &&
      input.files.length > 0
    ) {
      if (input.files[0] != null || '') {
        data.append('file', input.files[0] || this.state.user.picture_url);
      } else {
        data.append('file', imgFile[0]);
      }
    }
    const {boxList} = this.state;
    const _selectedLocation = boxList.find((x) =>
      this.idsEqual(x.id, this.state.selectedBoxId)
    );
    if (!_selectedLocation) {
      toast.error('Preferred Location is required for the selected parent account.');
      this.setState({ loader: false, isButtonDisabled: false });
      return;
    }
    data.append('id', this.state.user.id);
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('first_name', this.state.first_name);
    data.append('last_name', this.state.last_name);
    data.append('badge_id', this.state.badge_id);
    data.append('contact_id', this.state.user.contact.id);
    data.append('email', this.state.email);
    data.append('phone', this.state.phone);
    data.append('preferredlanguage', this.state.preferLanguage);
    data.append('selected_location_id', this.state.selectedBoxId);
    data.append('selected_location_type_id', _selectedLocation.locationtype_id);
    data.append('selected_location_name', _selectedLocation.value);
    data.append('group_id', this.state.groupId || null);
    // data.append('retail_flag', "false");
    if (this.state.roles && this.state.roles.length > 0) {
      data.append(
        'roles',
        this.state.roles.map((x) => x.id)
      );
    }

    const originalUser = this.state.user;
    const pictureChanged =
      input &&
      input.files !== null &&
      input.files !== undefined &&
      input.files.length > 0;
    const editSnapshot = {
      first_name: this.state.first_name,
      last_name: this.state.last_name,
      email: this.state.email,
      phone: this.state.phone,
      badge_id: this.state.badge_id,
      preferLanguage: this.state.preferLanguage,
      selectedBoxId: this.state.selectedBoxId,
      baselineSelectedBoxId: this.state.editAuditBaselineSelectedBoxId,
      groupId: this.state.groupId || null,
      parent_account_id: this.state.parent_account_id,
      roles: this.state.roles || [],
      pictureChanged: pictureChanged,
    };

    const result = fetch(process.env.REACT_APP_BASEURL + 'users', {
      method: 'PUT',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });
    result
      .then((result) => {
        result.json().then((res) => {
          this.setState({ loader: false });
          if (res.error) {
            this.setState({
              isButtonDisabled: false,
              submitted: false,

            });
            this.setState({ errorMessage: res.error.message });
          } else {
            const newData = this.state.data.filter(
              (x) => x.id !== this.state.user.id
            );
            newData.unshift(res.user);
            this.changeLanguage();
            const userLabel = !([null, undefined, ''].includes(res.user.username))
              ? res.user.username
              : res.user.first_name + ' ' + res.user.last_name;
            const roleIdsInScope = (this.state.roleLookupValues || []).map(
              (role) => role.id
            );
            const auditDescription = buildUserUpdatedAuditDescription(
              userLabel,
              originalUser,
              editSnapshot,
              { roleIdsInScope: roleIdsInScope }
            );
            if (auditDescription) {
              writeAuditLog(auditDescription, 'Manage User');
            }
            this.setState({
              isButtonDisabled: false,
              submitted: true,
              showNewUserDialog: false,
              user: {},
              avatarPreview: null,
              errorMessage: '',
              data: JSON.parse(JSON.stringify(newData)),
              searchtext: '',
            });
            let loggedInUser = sessionStorage.getItem('user');
            if(![undefined, 'undefined', null, 'null', ''].includes(loggedInUser)) {
              const parsedUser = JSON.parse(loggedInUser);
              if(parsedUser.username === res.user.id && res.preferredLocation) {
                localStorage.setItem('selectedLocation', res.preferredLocation.selected_location_id);
                localStorage.setItem('selectedLocationTypeId', res.preferredLocation.selected_location_type_id)
                localStorage.setItem('selected_location_name', res.preferredLocation.selected_location_name)
                // Notify Home header to re-read preferred location without requiring re-login
                window.dispatchEvent(new CustomEvent('preferredLocationChanged', {
                  detail: res.preferredLocation,
                }));
              }
            }
            toast.success(this.props.t('Toast.Success.UserUpdated'));
            FilterObj.searchtext = '';
            FilterObj.sortOrder = 'desc';
            FilterObj.sortColumn = 'created_on';
            FilterObj.tableName = '';
            this.BindBoxes();
          }
        });
      })
      .catch((error) => {
        this.setState({ loader: false });
        this.setState({ errorMessage: error.message });
      });
  };

  isSelected = (id) => this.state.selected.indexOf(id) !== -1;

  handleContextClick = (event, n, onReady) => {
    const {t} = this.props;
    const basePermissions = this.getManageUserActionPermissions();
    if (event && event.preventDefault) event.preventDefault();
    let disabledText;
    if ((n && n.is_enabled) === 'true' || (n && n.is_enabled) === true) {
      disabledText = t('Users.DisableActions');
    } else {
      disabledText = t('Report.inActive.Enable');
    }
    let disableUser = false;
    let currentUser = JSON.parse(sessionStorage.getItem('user')).username;
    if (n && n.id === currentUser) {
      disableUser = true;
    }

    const guestFlags = (n && n.is_guest_user === true)
      ? {
          userresetpassword: false,
          userunlockuser: false,
          useredit: false,
          guestusersecurebadgeprint: true,
          guestusersecurebadgedownload: true,
          guestusersecurebadgeemail: true,
        }
      : {
          userresetpassword: basePermissions.userresetpassword,
          userunlockuser: basePermissions.userunlockuser,
          useredit: basePermissions.useredit,
          guestusersecurebadgeprint: false,
          guestusersecurebadgedownload: false,
          guestusersecurebadgeemail: false,
        };

    const next = {
      ...guestFlags,
      selectedRowId: n && n.id,
      disabledText: disabledText,
      isDisabled: disableUser,
      currentContextUsername: (![null, undefined, ''].includes(n && n.username) ? n.username : ((n && n.first_name) || '') + ' ' + ((n && n.last_name) || '')),
    };
    // Avoid setState when opening ⋮ menu — full page re-render causes flicker.
    if (typeof onReady === 'function') {
      // Intentional: skip setState so opening ⋮ does not re-render the page.
      // eslint-disable-next-line react/no-direct-mutation-state
      Object.assign(this.state, next);
      onReady();
      return;
    }
    this.setState(next);
  };

  handleContextClose = (event) => {
    if (event && event.preventDefault) event.preventDefault();
    this.setState({ selectedRowId: null, contextMenuUsed: null, currentContextUsername: '' });
  };

  openRowActionsMenu = (event, params, menuHelpers) => {
    const openMenu = () => {
      const items = this.getContextMenuItems({
        ...params,
        column: params.column,
        node: params.node,
        value: params.value,
      });
      if (menuHelpers && typeof menuHelpers.openMenu === 'function') {
        menuHelpers.openMenu(items);
        return;
      }
      openAgGridContextMenu(params, (menuHelpers && menuHelpers.positionEvent) || event);
    };
    this.handleContextClick(event, params && params.data, openMenu);
  };

  getContextMenuItems = (params) => {
    const colId = params && params.column && (params.column.getColId ? params.column.getColId() : params.column.colId);
    if (colId !== 'actions') return [];
    const {t} = this.props;
    if (!(params.node && params.node.data)) return [];
    const {
      userview,
      useredit,
      userdelete,
      userdisabled,
      userresetpassword,
      userunlockuser,
      guestusersecurebadgeprint,
      guestusersecurebadgedownload,
      guestusersecurebadgeemail,
      isDisabled,
      disabledText,
    } = this.state;
    const items = [];
    if (userview === true) {
      items.push(actionMenuItem({ name: t('Users.ViewActions'), icon: 'view', action: () => this.handleView() }));
    }
    if (useredit === true) {
      items.push(actionMenuItem({ name: t('Users.EditActions'), icon: 'edit', action: () => this.handleEdit() }));
    }
    if (userdelete === true) {
      items.push(actionMenuItem({
        name: t('Users.DeleteActions'),
        icon: 'delete',
        disabled: isDisabled === true,
        action: () => this.confirmDelete(),
      }));
    }
    if (userdisabled === true) {
      items.push(actionMenuItem({
        name: disabledText,
        icon: 'disable',
        disabled: isDisabled === true,
        action: () => this.confirmDisable(),
      }));
    }
    if (userresetpassword === true) {
      items.push(actionMenuItem({ name: t('Users.ResetPasswordActions'), icon: 'password', action: () => this.confirmResetPSWD() }));
    }
    if (userunlockuser === true) {
      items.push(actionMenuItem({ name: t('Users.UnlockUser'), icon: 'unlock', action: () => this.handleUnlockUser() }));
    }
    if (guestusersecurebadgeprint === true) {
      items.push(actionMenuItem({ name: t('Home.SecureBadgePopup.Print'), icon: 'print', action: () => this.handleGuestUserPrint() }));
    }
    if (guestusersecurebadgedownload === true) {
      items.push(actionMenuItem({ name: t('Home.SecureBadgePopup.Download'), icon: 'download', action: () => this.handleGuestUserDownload() }));
    }
    if (guestusersecurebadgeemail === true) {
      items.push(actionMenuItem({ name: t('Home.SecureBadgePopup.Email'), icon: 'email', action: () => this.handleGuestUserEmail() }));
    }
    return items;
  };

  //user disable
  confirmDisable = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        disableDialogOpen: true,
        forDisable: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        disableDialogOpen: true,
        forDisable: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  //user disable
  confirmResetPSWD = (event) => {
    let selectedObject = {};
    if (this.state.selectedRowId) {
      selectedObject = this.state.data.find(
        (x) => x.id === this.state.selectedRowId
      );
    } else {
      selectedObject = this.state.data.filter(
        (x) => this.state.selected.indexOf(x.id) > -1
      );
    }
    console.log('Confirm Reset Password for', {
      selectedObject,
      selecteddID: this.state.selectedRowId,
    });
    fetch(process.env.REACT_APP_BASEURL + 'adminUser-pswdReset', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: selectedObject && selectedObject.username,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log({ confirmResetPSWD_res: res });
        this.handleContextClose(event);
        toast.success(this.props.t('Toast.Request.ResetPassword'));
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.message);
      });
  };

  disableConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        disableDialogOpen: false,
        selectedRowId: null,
        forDisable: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        disableDialogOpen: false,
        selectedRowId: null,
        forDisable: null,
      });
    }
  };

  disableConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDisable(event);
    } else {
      this.disableUsers();
    }
    this.setState({ disableDialogOpen: false });
    toast.success(
      `${this.props.t('Toast.User')} ${this.state && this.state.disabledText} ${this.props.t('Toast.Success')}`
    );
  };

  handleDisable = (event) => {
    this.setState({ loader: true });
    const rowIdToDisable = this.state.selectedRowId;
    const DisUser = {
      id: rowIdToDisable,
      is_enabled:
        this.state && this.state.disabledText.toLowerCase() === 'disable'
          ? false
          : true,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + 'userdis/', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(DisUser),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
    result.then((result) => {
      const {currentContextUsername, disabledText} = this.state;
      writeAuditLog(`'${(currentContextUsername !== '') ? currentContextUsername : 'User '}' is ${(disabledText.toLowerCase() !== '') ? disabledText.toLowerCase() : ' updated '} by User.`, 'Manage Users');
      this.setState({ loader: false });
      this.handleContextClose(event);
      this.BindBoxes();
    });
  };

  handleStoreChange = (event) => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex((x) => x.id === '-1');
    if (event.target.value.length === 1 && AllprocessedIndex > -1) {
      const element = event.target.value[AllprocessedIndex];
      chipprocessed.push(element);
      for (let i = 0; i < this.state.roleLookupValues.length; i++) {
        processed.push(this.state.roleLookupValues[i]);
      }
    } else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
      for (let i = 0; i < this.state.roleLookupValues.length; i++) {
        const element = storeid.findIndex(
          (x) => x.id === this.state.roleLookupValues[i].id
        );
        if (element > -1) {
        } else {
          chipprocessed.push(this.state.roleLookupValues[i]);
          processed.push(this.state.roleLookupValues[i]);
        }
      }
    } else if (storeid.length === 0 && AllprocessedIndex === -1) {
      chipprocessed = [];
      processed = [];
    } else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        } else {
        }
      }
    }
    this.setState({
      chipstores: chipprocessed,
      roles: processed,
      rolesError: null,
      guestFormData: { ...this.state.guestFormData, rolesError: null },
    });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id);
        }
      }
    }
  };
  handleTabChange = (event, value) => {
    this.setState({ selectedTab: value });
  };

  handleChangeIndex(index) {
    this.setState({ selectedTab: index });
  }

  handleWorkDayStartsChange = (startDays) => {
    this.setState({ workDayStarts: startDays });
  };

  handleWorkDayEndsChange = (endDays) => {
    this.setState({ workDayEnds: endDays });
  };

  handleCheckboxChange = (event) => {
    const value = event && event.target.name;
    switch (value) {
      case 'defaultReminder':
        this.setState({ defaultReminder: !this.state.defaultReminder });
        break;

      case 'ReminderSelect':
        this.setState({ reminderSelectID: event.target.value });
        break;

      case 'sunday':
        this.setState({ sunday: !this.state.sunday });
        break;

      case 'monday':
        this.setState({ monday: !this.state.monday });
        break;

      case 'tuesday':
        this.setState({ tuesday: !this.state.tuesday });
        break;

      case 'wednesday':
        this.setState({ wednesday: !this.state.wednesday });
        break;

      case 'thursday':
        this.setState({ thursday: !this.state.thursday });
        break;

      case 'friday':
        this.setState({ friday: !this.state.friday });
        break;

      case 'saturday':
        this.setState({ saturday: !this.state.saturday });
        break;

      case 'email':
        this.setState({ emailNotify: !this.state.emailNotify });
        break;

      case 'sms':
        this.setState({ smsNotify: !this.state.smsNotify });
        break;

      case 'push':
        this.setState({ pushNotify: !this.state.pushNotify });
        break;

      default:
        return null;
    }
  };

  handleCloseReminderSelect = () => {
    this.setState({ isOpenReminderSelect: false });
  };

  hanldeOpenReminderSelect = () => {
    this.setState({ isOpenReminderSelect: true });
  };
  // -- Need to enable when we deployed appountments.
  handleSubmitScheduleCalendar = (event) => {
    event.preventDefault();
    this.setState({ loader: true, isDisabledScheduleButton: true });
    try {
      const saveScheduleCalendar = {
        workDayStart: this.state && this.state.workDayStarts,
        workDayEnd: this.state && this.state.workDayEnds,
        reminder:
          this.state.defaultReminder === true
            ? '5m'
            : this.state.reminderSelectID,
        isDefaultReminder: this.state && this.state.defaultReminder,
        isSunday: this.state && this.state.sunday,
        isMonday: this.state && this.state.monday,
        isTuesday: this.state && this.state.tuesday,
        isWednesday: this.state && this.state.wednesday,
        isThursday: this.state && this.state.thursday,
        isFriday: this.state && this.state.friday,
        isSaturday: this.state && this.state.saturday,
        isEmail: this.state && this.state.emailNotify,
        isSms: this.state && this.state.smsNotify,
        isPush: this.state && this.state.pushNotify,
        userId: this.state && this.state.rowID,
        accountId: this.state && this.state.parentID,
      };
      fetch(process.env.REACT_APP_BASEURL + 'schedule/user-schedule-calender', {
        method: 'POST',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(saveScheduleCalendar),
      })
        .then((res) => {
          try {
            return res.json();
          } catch (error) {
            return error;
          }
        })
        .then((response) => {
          if (response && response.status === 200) {
            if (
              response &&
              response._response &&
              response._response.createSchedule
            ) {
              this.setState({
                loader: false,
                isDisabledScheduleButton: false,
                showNewUserDialog: false,
                rowID: null,
                parentID: null,
              });
              toast.success(this.props.t('Toast.Success.ScheduleCalenderCreated'));
              this.BindBoxes();
              this.setState({
                workDayStarts: new Date(),
                workDayEnds: new Date(),
                reminderSelectID: '5m',
                defaultReminder: false,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                emailNotify: false,
                smsNotify: false,
                pushNotify: false,
                rowID: false,
                parentID: false,
              });
            } else {
              this.setState({
                loader: false,
                isDisabledScheduleButton: false,
                showNewUserDialog: false,
                rowID: null,
                parentID: null,
              });
              toast.success(this.props.t('Toast.Success.ScheduleCalenderUpdated'));
              this.BindBoxes();
              this.setState({
                workDayStarts: new Date(),
                workDayEnds: new Date(),
                reminderSelectID: '5m',
                defaultReminder: false,
                sunday: false,
                monday: false,
                tuesday: false,
                wednesday: false,
                thursday: false,
                friday: false,
                saturday: false,
                emailNotify: false,
                smsNotify: false,
                pushNotify: false,
                rowID: false,
                parentID: false,
              });
            }
          } else if (response && response.status === 500) {
            this.setState({
              loader: false,
              isDisabledScheduleButton: false,
              showNewUserDialog: false,
              rowID: null,
              parentID: null,
            });
            toast.error(response.res.error);
          }
        })
        .catch((error) => {
          this.setState({
            loader: false,
            isDisabledScheduleButton: false,
            showNewUserDialog: false,
            rowID: null,
            parentID: null,
          });
        });
    } catch (error) {
      console.log(error);
    }
  };

  onChangePreferredLanguage = (event) => {
    event.preventDefault && event.preventDefault();
    const { value } = event.target;
    this.setState({ preferLanguage: value });
  };

  handleUnlockUser = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.setState({ selectedUserEmailToAuthenticat: selectedObject.username, authenticateUnlockUserDialogConfirmation: true, loader: false }, () => {
      console.log(this.state.selectedUserEmailToAuthenticat);
    })
    this.handleContextClose(event);
  }

  handleGuestUserPrint = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );

    this.setState({
      printGuestSecureBadgeQR : true,
      guestQrCodeImg: selectedObject.securebadgecode,
      contextMenuUsed: true
    });
    setTimeout(() => {
      window.print();
      this.setState({
        printGuestSecureBadgeQR: false,   
        loader: false,  
        errorMessage: '', 
        showGuestUserDialog: false, 
        dialogEmailAlreadyExistsForGuest: false, 
        activeStep: 0,  
        secureBadgeAction: 'print', 
        guestFormData: {},
        selectedBoxId: '', 
        guestQrCodeImg: null,
        /* removing context menu */
        anchorEl: null, 
        selectedRowId: null, 
        contextMenuUsed: null
        /* removing context menu */
      });
    }, 1200);
 
  }

  handleGuestUserDownload = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    ); 

    try {
      // get content from the s3 bucket 
      const Obj = {
        url : selectedObject.securebadgecode
      };
      fetch(process.env.REACT_APP_BASEURL + 'downloadSecureBadge', {
        method: 'post',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
        body: JSON.stringify(Obj),
      })
      .then((response) => response.json())
      .then(res => {
          const link = document.createElement('a');
          link.href = res.url;            
          link.target = "_Blank";
          link.download = "secure_badge.png"
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          this.setState({
            loader: false,  
            errorMessage: '',
            secureBadgeAction: 'print', 
            showGuestUserDialog: false, 
            dialogEmailAlreadyExistsForGuest: false, 
            activeStep: 0, 
            guestQrCodeImg: null, 
            printGuestSecureBadgeQR: false,
            guestFormData: {},
            selectedBoxId: '',
            /* removing context menu */
            anchorEl: null, 
            selectedRowId: null, 
            contextMenuUsed: null
            /* removing context menu */
          });
          res.success ? toast.success(res.message, { className: 'topAlignment'}) : toast.error(res.message, { className: 'topAlignment'});   
      })
      .catch(error => {
        console.error(`Error during fetching secure badge file content : ${error}`);
      });
    } catch (error) {
      console.error('Error generating URL:', error);
    }
  }

  handleGuestUserEmail = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.setState({
      showGuestUserDialog : true,
      activeStep: 1,
      secureBadgeAction: 'email',
      guestFormData: {
        ...this.state.guestFormData,
        firstName: selectedObject.first_name,
        lastName: selectedObject.last_name,
        email: selectedObject.username,
        userId: selectedObject.id,
        userEmail: selectedObject.username,
      },      
      guestQrCodeImg: selectedObject.securebadgecode,
      contextMenuUsed: true
    });
    

    //this.handleContextClose(event);
  }

  handleAuthenticateUnlockUserDialogConfirmationClose = () => {
    this.setState({ authenticateUnlockUserDialogConfirmation: false })
  }
  processUserUnlock = () => {
    const {selectedUserEmailToAuthenticat} = this.state;
    let _apiEndPoint = `${process.env.REACT_APP_BASEURL}connect/auth/user/reset-request`;
    fetch(_apiEndPoint, {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({ email: selectedUserEmailToAuthenticat })
    })
      .then((response) => response.json())
      .then((eventResponse) => {
        this.BindBoxes();
        console.info(`Response from reset-request ${JSON.stringify(eventResponse, null, 2)}`)
        this.setState({
          authenticateUnlockUserDialogConfirmation: false,
          loader: false
        })
      }).catch((error) => {
        console.info(`Error response from reset-request ${JSON.stringify(error, null, 2)}`)
        this.setState({
          authenticateUnlockUserDialogConfirmation: false,
          loader: false
        })
        toast.error(error.message + ': ' + error.errorMessage);
      })
  }

  exportCSV = () => {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/UserList', {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(FilterObj),
    })
      .then(response => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then(csvData => {
        let csvRow = [];
        let Array = [['Id', 'Name', 'UserName', 'Assocaited Account', 'Email', 'Phone', 'Roles', 'Last Login', 'Status']];
        let result = csvData && csvData.Results && csvData.Results.length > 0 ? csvData.Results : [];
        if (result && result.length > 0) {
          for (let i = 0; i < result.length; i++) {
            Array.push(
              [
                result[i] && result[i].name ? result[i].name : '',
                result[i] && result[i].username ? result[i].username : '',
                result[i] && result[i].parentAccount && result[i].parentAccount.name ? result[i].parentAccount.name : '',
                result[i] && result[i].contact && result[i].contact.email ? result[i].contact.email : '',
                result[i] && result[i].contact && result[i].contact.phone ? result[i].contact.phone : '',
                result[i] && result[i].roles && result[i].roles.length > 0 && result[i].roles[0].name ? result[i].roles[0].name : '',
                result[i] && result[i].last_login_on ? this.convertToTimeZone(result[i].last_login_on) : '',
                [true, 'true'].includes(result[i] && result[i].is_enabled) ? 'Enabled' : 'Disabled'
              ]
            )
          }
          console.log(Array, "Array", result, "result")
          for (let i of Array) {
            csvRow.push(i.join(","));
          }
          const csvString = csvRow.join('\n');
          const csvBlob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
          const downloadUrl = window.URL.createObjectURL(csvBlob);
          const element = document.createElement("a");
          element.href = downloadUrl;
          element.target = "_Blank";
          element.download = "UserListReport.csv";
          document.body.appendChild(element);
          element.click();
          document.body.removeChild(element);
          window.URL.revokeObjectURL(downloadUrl);
        }
        this.setState({ loader: false });
      })
  };

  getLocationsByAccount = () => {
    const parentAccountId = sessionStorage.getItem('parentAccountId');
    if(![undefined, undefined, null, null, ''].includes(parentAccountId)) {
      fetch(`${process.env.REACT_APP_BASEURL}getBoxesByStoreId/${parentAccountId}`, {
        method: 'GET',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        }
      })
        .then((response) => response.json())
        .then((locationResponse) => {
          const boxList =
            locationResponse.length > 0
              ? locationResponse.map((x) => {
                  return {
                    id: x.id,
                    value: x.name,
                    locationtype_id: x.location_type_id,
                    parent_account_id: x.parent_account_id,
                    address: x.address
                  };
                })
              : [];

          // Re-resolve for Add/Edit user dialog and guest user dialog.
          // Installer keeps its own location/group rules (installer sends group_id '').
          if (
            (this.state.showNewUserDialog || this.state.showGuestUserDialog) &&
            this.state.parent_account_id
          ) {
            const currentGroup = (this.state.groups || []).find((group) =>
              this.idsEqual(group.id, this.state.groupId)
            );
            const deps = this.applyParentAccountDependencies(
              this.state.parent_account_id,
              {
                boxList,
                preferExistingGroupId: this.state.groupId,
                preferExistingLocationId: this.state.selectedBoxId,
                preferredTypeId: currentGroup
                  ? currentGroup.type_id
                  : sessionStorage.getItem('groupType'),
                forceDefaultLocation: this.isEmptyValue(this.state.selectedBoxId),
              }
            );
            this.setState({
              boxList,
              selectedAccountBoxList: deps.filteredBoxList,
              selectedBoxId: deps.selectedBoxId,
              selectedLocationTypeId: deps.selectedLocationTypeId,
              selected_location_name: deps.selected_location_name,
              filteredGroup: deps.filteredGroup,
              groupId: deps.groupId,
            });
            return;
          }

          this.setState({
            boxList,
            selectedBoxId: boxList.length > 0 ? boxList[0].id : '',
          });
        }).catch((error) => {
          console.info(`Error response from locations ${JSON.stringify(error, null, 2)}`)
          this.setState({ boxList: [] })
          toast.error(error.message);
        })
    }
  }

  handleBoxChange = (event) => {
    const {boxList} = this.state;
    const _selectedLocation = boxList.find((x) =>
      this.idsEqual(x.id, event.target.value)
    );
    if (!_selectedLocation) {
      return;
    }
    this.setState({
      selectedBoxId: _selectedLocation.id,
      selectedLocationTypeId: _selectedLocation.locationtype_id,
      selected_location_name: _selectedLocation.value,
      installerUserDetails: {
        ...this.state.installerUserDetails,
        lastName: _selectedLocation.value,
      }
    })
  }

  getManageUserActionPermissions = () => {
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));
    let checkUserRole = JSON.parse(sessionStorage.getItem("permissionUser"));

    if (checkUserRole === USER_ROLES.SUPERADMIN) {
      return {
        userview: true,
        useradd: true,
        useredit: true,
        userdelete: true,
        userdisabled: true,
        userresetpassword: true,
        userunlockuser: true,
      };
    }

    if (permissions && permissions.length > 0) {
      const manageUsersPermissions = permissions.filter((item) => {
        return item.permission_entity_type === "Manage Users";
      });

      if (manageUsersPermissions.length > 0) {
        return {
          useradd: manageUsersPermissions.some((x) => x.name.trim() === 'Add' && x.is_allowed === 1),
          useredit: manageUsersPermissions.some((x) => x.name.trim() === 'Modify' && x.is_allowed === 1),
          userview: manageUsersPermissions.some((x) => x.name.trim() === 'View' && x.is_allowed === 1),
          userdelete: manageUsersPermissions.some((x) => x.name.trim() === 'Delete' && x.is_allowed === 1),
          userdisabled: manageUsersPermissions.some((x) => x.name.trim() === 'Disabled' && x.is_allowed === 1),
          userresetpassword: manageUsersPermissions.some((x) => x.name.trim() === 'Reset Password' && x.is_allowed === 1),
          userunlockuser: manageUsersPermissions.some((x) => x.name.trim() === 'Unlock User' && x.is_allowed === 1),
        };
      }
    }

    return {
      userview: false,
      useradd: false,
      useredit: false,
      userdelete: false,
      userdisabled: false,
      userresetpassword: false,
      userunlockuser: false,
    };
  }

  setPermissions = () => {
    this.setState(this.getManageUserActionPermissions());
  }

  handleInputChange = (event) => {
    this.setState({ groupId: event.target.value });
  };

  isEmptyValue = (value) =>
    [undefined, 'undefined', null, 'null', ''].includes(value);

  /** Loose id equality — API / session / MUI Select often mix string vs number. */
  idsEqual = (a, b) => {
    if (this.isEmptyValue(a) || this.isEmptyValue(b)) {
      return false;
    }
    return a === b || String(a) === String(b);
  };

  loggedInUserHasGroup = () => {
    const groupType = sessionStorage.getItem('groupType');
    const groupID = sessionStorage.getItem('groupID');
    return !this.isEmptyValue(groupType) || !this.isEmptyValue(groupID);
  };

  /**
   * Account ids for the selected parent and all descendant child accounts
   * (matches ltree: account_lineage <@ parent.account_lineage).
   */
  getAccountIdsForParentTree = (parentAccountId) => {
    if (this.isEmptyValue(parentAccountId)) {
      return [];
    }
    const accounts =
      (this.state.accountsList && this.state.accountsList.length > 0)
        ? this.state.accountsList
        : (this.state.accountValues || []).map((a) => ({
            id: a.value,
            account_lineage: a.account_lineage,
          }));

    const parent = accounts.find((a) =>
      this.idsEqual(a.id || a.value, parentAccountId)
    );
    if (!parent) {
      return [parentAccountId];
    }

    const parentLineage = String(parent.account_lineage || '');
    if (!parentLineage) {
      return [parent.id || parent.value || parentAccountId];
    }

    return accounts
      .filter((a) => {
        const lineage = String(a.account_lineage || '');
        if (!lineage) {
          return this.idsEqual(a.id || a.value, parentAccountId);
        }
        return (
          lineage === parentLineage ||
          lineage.startsWith(`${parentLineage}.`)
        );
      })
      .map((a) => a.id || a.value);
  };

  getFilteredLocationsForParent = (parentAccountId, boxList = this.state.boxList) => {
    if (this.isEmptyValue(parentAccountId)) {
      return [];
    }
    const allowedAccountIds = this.getAccountIdsForParentTree(parentAccountId);
    return (boxList || []).filter((box) =>
      allowedAccountIds.some((id) => this.idsEqual(box.parent_account_id, id))
    );
  };

  /**
   * Resolve preferred location + group when parent account changes or edit opens.
   * Call sites: parent onChange, Add/Edit open, locations loaded (Add/Edit only).
   * - Locations: filtered to parent only; keep existing if valid, else first.
   * - Groups: when actor has a group, require a selection (prefer existing →
   *   actor's group id under parent → same name as actor's group → first).
   *   When actor has no group, keep existing / same type if possible, else empty.
   */
  applyParentAccountDependencies = (parentAccountId, options = {}) => {
    const {
      preferExistingGroupId,
      preferExistingLocationId,
      preferredTypeId,
      groups = this.state.groups,
      boxList = this.state.boxList,
      forceDefaultLocation = false,
      skipGroupAutoSelect = false,
    } = options;

    const filteredBoxList = this.getFilteredLocationsForParent(
      parentAccountId,
      boxList
    );
    let selectedBox = null;
    if (
      !forceDefaultLocation &&
      !this.isEmptyValue(preferExistingLocationId)
    ) {
      selectedBox = filteredBoxList.find((box) =>
        this.idsEqual(box.id, preferExistingLocationId)
      );
    }
    if (!selectedBox) {
      selectedBox = filteredBoxList[0] || null;
    }

    const allowedAccountIds = this.getAccountIdsForParentTree(parentAccountId);
    const filteredGroup = (groups || []).filter((group) =>
      allowedAccountIds.some((id) =>
        this.idsEqual(group.parent_account_id, id)
      )
    );
    const loggedInHasGroup = this.loggedInUserHasGroup();
    const loggedInGroupId = sessionStorage.getItem('groupID');
    const loggedInGroupName = sessionStorage.getItem('groupName');
    let groupId = '';

    if (skipGroupAutoSelect) {
      if (
        !this.isEmptyValue(preferExistingGroupId) &&
        filteredGroup.some((group) =>
          this.idsEqual(group.id, preferExistingGroupId)
        )
      ) {
        const matched = filteredGroup.find((group) =>
          this.idsEqual(group.id, preferExistingGroupId)
        );
        groupId = matched ? matched.id : '';
      }
    } else if (
      !this.isEmptyValue(preferExistingGroupId) &&
      filteredGroup.some((group) => this.idsEqual(group.id, preferExistingGroupId))
    ) {
      const matched = filteredGroup.find((group) =>
        this.idsEqual(group.id, preferExistingGroupId)
      );
      groupId = matched ? matched.id : preferExistingGroupId;
    } else if (loggedInHasGroup) {
      if (
        !this.isEmptyValue(loggedInGroupId) &&
        filteredGroup.some((group) => this.idsEqual(group.id, loggedInGroupId))
      ) {
        const matched = filteredGroup.find((group) =>
          this.idsEqual(group.id, loggedInGroupId)
        );
        groupId = matched ? matched.id : '';
      } else if (!this.isEmptyValue(loggedInGroupName)) {
        const byName = filteredGroup.find(
          (group) =>
            String(group.name || '').toLowerCase() ===
            String(loggedInGroupName).toLowerCase()
        );
        groupId = byName ? byName.id : '';
      }
      if (this.isEmptyValue(groupId) && filteredGroup.length > 0) {
        groupId = filteredGroup[0].id;
      }
    } else if (!this.isEmptyValue(preferredTypeId)) {
      const sameType = filteredGroup.find(
        (group) => String(group.type_id) === String(preferredTypeId)
      );
      groupId = sameType ? sameType.id : '';
    }

    return {
      filteredBoxList,
      selectedBoxId: selectedBox ? selectedBox.id : '',
      selectedLocationTypeId: selectedBox ? selectedBox.locationtype_id : '',
      selected_location_name: selectedBox ? selectedBox.value : '',
      filteredGroup,
      groupId,
    };
  };

  handleParentAccountChange = (e) => {
    const parentAccountId = e.target.value;
    const currentGroup = (this.state.groups || []).find((group) =>
      this.idsEqual(group.id, this.state.groupId)
    );
    const preferredTypeId = currentGroup
      ? currentGroup.type_id
      : sessionStorage.getItem('groupType');
    const deps = this.applyParentAccountDependencies(parentAccountId, {
      preferredTypeId,
      forceDefaultLocation: true,
      preferExistingGroupId: this.loggedInUserHasGroup()
        ? null
        : this.state.groupId,
    });

    this.setState({
      parent_account_id: parentAccountId,
      selectedAccountBoxList: deps.filteredBoxList,
      selectedBoxId: deps.selectedBoxId,
      selectedLocationTypeId: deps.selectedLocationTypeId,
      selected_location_name: deps.selected_location_name,
      filteredGroup: deps.filteredGroup,
      groupId: deps.groupId,
    });

    if (parentAccountId !== undefined) {
      this.fetchBadgeDuration(parentAccountId);
    }
  };

  fetchBadgeDuration = async (id) => {
    try {
      this.setState({ loader: true });
      const result = fetch(`${process.env.REACT_APP_BASEURL}getbadgeduration`, {
        method: "POST",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ param : id})
      }
      );
      result
        .then((result) => result.json())
        .then((result) => {
            this.setState({ loader: false, secureBadgeExpiry : result.data });
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };
 

  fetchGroupsList = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      });
      const resLocation = await response.json();
      return (resLocation && resLocation.data) || [];
    } catch (error) {
      console.error("Error fetching groups:", error);
      return this.state.groups || [];
    }
  };

  refreshGroupsForModal = async (parentAccountId, groupId, preferredLocationId) => {
    const groups = await this.fetchGroupsList();
    const preferredTypeId = (() => {
      const existing = (groups || []).find((group) =>
        this.idsEqual(group.id, groupId)
      );
      return existing
        ? existing.type_id
        : sessionStorage.getItem('groupType');
    })();
    const deps = this.applyParentAccountDependencies(parentAccountId, {
      groups,
      preferExistingGroupId: groupId,
      preferExistingLocationId:
        preferredLocationId !== undefined
          ? preferredLocationId
          : this.state.selectedBoxId,
      preferredTypeId,
    });
    this.setState({
      groups,
      filteredGroup: deps.filteredGroup,
      groupId: deps.groupId,
      selectedAccountBoxList: deps.filteredBoxList,
      selectedBoxId: deps.selectedBoxId,
      selectedLocationTypeId: deps.selectedLocationTypeId,
      selected_location_name: deps.selected_location_name,
      // When preferred location was empty, form seeds a default — lock that as
      // the audit baseline so seeded defaults are not logged as changes.
      editAuditBaselineSelectedBoxId: this.isEmptyValue(preferredLocationId)
        ? deps.selectedBoxId
        : preferredLocationId,
    });
  };

  fetchSuggestions = async () => {
    const groups = await this.fetchGroupsList();
    this.setState({ groups, filteredGroup: groups });
  }; 
  handleInstallerParentAccountChange = (e) => {
    const { value } = e.target;
    const {accountValues} = this.state;
    const selectedOption = accountValues.find(option => option.value === value);
    const label = selectedOption ? selectedOption.label : '';
    const filteredList = this.state.boxList.filter((box) => box.parent_account_id === value);
    const filteredBoxList = filteredList.length > 0 ? filteredList : this.state.boxList
    this.setState({
      parent_account_id: value,
      selectedAccountBoxList: filteredBoxList,
      selectedBoxId: filteredBoxList[0].id,
      selectedLocationTypeId: filteredBoxList[0].locationtype_id,
      selected_location_name:filteredBoxList[0].value,
      installerUserDetails: {
        ...this.state.installerUserDetails,
        lastName: filteredBoxList[0].value,
        firstName: label,
      }
    })
  }

  handleInstallerFormSubmit = () => {
    var data = new FormData();
    let _selectedLocation
    const {boxList, selectedBoxId} = this.state;
    if ([null, undefined, 'undefined', ''].includes(selectedBoxId)) {
      _selectedLocation = boxList[0];
    } else {
      _selectedLocation = boxList.filter((x) => x.id === this.state.selectedBoxId)[0];
    }
    this.setState({installBadgeBoxLocation: _selectedLocation && _selectedLocation.address})
    data.append('parent_account_id', this.state.parent_account_id);
    data.append('firstName', this.state.installerUserDetails.firstName);
    data.append('lastName', this.state.installerUserDetails.lastName);
    data.append('selected_location_id', this.state.selectedBoxId);
    data.append('selected_location_type_id', _selectedLocation.locationtype_id);
    data.append('selected_location_name', _selectedLocation.value);
    data.append('group_id', '');
    if (this.state.roles && this.state.roles.length > 0) {
      data.append(
        'roles',
        this.state.roles.map((x) => x.id)
      );
    }
    this.setState({ loader: true })
    const result = fetch(process.env.REACT_APP_BASEURL + 'installerUser', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: data,
    });

    result
      .then((result) => result.json())
      .then((res) => {
        if ([true, 'true'].includes(res.success)) {
          toast.success("Installer badge created successfully!", {autoClose: 1000});
          this.setState({
            installerSecureBadgeQR: res.secureBadge,
            printInstallerSecureBadge: true
          })
          setTimeout(() => {
            toast.dismiss();
            window.print();
            this.setState({
              printInstallerSecureBadge: false,
              installerUserDetails: {},
            })
          }, 2000);
        } else {
          toast.error("Error while creating installer badge.");
        }
        this.setState({
          showInstallerDialog: false,
          loader:false,
          anchorEl: null, 
          selectedRowId: null, 
          contextMenuUsed: null,
        })
      })
      .catch((error) => {
        this.setState({
          installerUserDetails: {},
          showInstallerDialog: false,
          loader:false,
          anchorEl: null, 
          selectedRowId: null, 
          contextMenuUsed: null,
        })
      });
  }
 
  componentDidUpdate(prevProps, prevState) {
    // Re-open preferences modal when navigating (back) to /users/1 (e.g. after Cancel then Preferences again)
    const pathname = typeof window !== 'undefined' && window.location ? window.location.pathname : '';
    const isPreferencesRoute = pathname.endsWith('/users/1');
    const wasPreferencesRoute = this._prevPathname.endsWith('/users/1');
    if (isPreferencesRoute && this.state.loadState === 0 && !wasPreferencesRoute) {
      this.openUserPopup();
    }
    const editUserId = this.getEditUserIdFromQuery();
    if (editUserId && !this.state.openedEditFromAccount) {
      this.openEditFromAccountDeepLink();
    }
    this._prevPathname = pathname;

    // Keep the group dropdown filtered when parent_account_id changes via
    // paths that only set parent (e.g. open Edit). Selection defaults are
    // owned by handleParentAccountChange / refreshGroupsForModal / addUser /
    // getLocationsByAccount — do not heal location here (avoids hidden state).
    if (prevState.parent_account_id !== this.state.parent_account_id) {
      this.setState({
        filteredGroup: this.state.groups.filter((group) =>
          this.getAccountIdsForParentTree(this.state.parent_account_id).some(
            (id) => this.idsEqual(group.parent_account_id, id)
          )
        ),
      });
    }
  }

  componentWillUnmount() {
      FilterObj.searchtext = '';
      // Remove custom validator when the component unmounts
      ValidatorForm.removeValidationRule('isValidEmail');
  }

  render() {
    const {classes, theme, t} = this.props;
    const {selected, user, preferLanguage, locale, boxList, selectedBoxId, groupId, filteredGroup} = this.state;
    const readOnly = this.state.operation === 'View';
    const preferredLocationBoxList = this.getFilteredLocationsForParent(
      this.state.parent_account_id,
      boxList
    );
    const loggedInUserHasGroup = this.loggedInUserHasGroup();
    // Normalize ids to strings so SearchableSelect strict === matches without
    // changing the shared component (used by home, patients, groups, etc.).
    const preferredLocationItems = (preferredLocationBoxList || []).map(
      (box) => ({ id: String(box.id), name: box.value })
    );
    const preferredLocationValue = (() => {
      const match = (preferredLocationBoxList || []).find((box) =>
        this.idsEqual(box.id, selectedBoxId)
      );
      return match ? String(match.id) : '';
    })();
    let disableSelect = false;
    const steps = [t('Users.Guest.GuestUserInfo'),t('Users.Guest.YourSecureBadge')];

    if (this.state.operation === 'View') {
      disableSelect = true;
    } else {
      disableSelect = false;
    }
    return (
      <div className={classes.root}>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <Dialog
          open={this.state.authenticateUnlockUserDialogConfirmation || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText>
              <p>
                {t('Account.Terms.PurgeServicePopupFinalConfirmationMessage')}
              </p>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.processUserUnlock(event)}
              color='primary'
              disabled={this.state.loader === true}
            >
              {t('Global.Consultation.Action.Yes')}
            </Button>
            <Button
              onClick={(event) => this.handleAuthenticateUnlockUserDialogConfirmationClose(event)}
              color='primary'
              disabled={this.state.loader === true}
            >
              {t('Global.Consultation.Action.No')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Users.AreYouSureDeleteText')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Users.AreYouSureDeleteBodyText')} :
              <ul>
                {this.state.forDeletion &&
                  this.state.forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Users.AreYouSureDeleteCancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Users.AreYouSureDeleteButton')}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.disableDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{`Are you sure you want to ${this
            .state && this.state.disabledText}?`}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Users.AreYouSureWantTo')}{' '}
              {this.state && this.state.disabledText} {t('Users.users')}:
              <ul>
                {this.state.forDisable &&
                  this.state.forDisable.map(function (x) {
                    return <li>{x.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.disableConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Users.CancelButton')}
            </Button>
            <Button
              onClick={this.disableConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Users.YES')}
            </Button>
          </DialogActions>
        </Dialog>

        

{/*   Add guest user popup starts        */}
                <Dialog
                  open={ this.state.dialogEmailAlreadyExistsForGuest || false } 
                >
                  <DialogTitle id='alert-dialog-title'>
                    {t('Users.DoYouWantToContinue')}
                  </DialogTitle>
                  <DialogContent> 
                      <div sx={{ display: 'flex', alignItems: 'center' }}>                
                        {t('Users.AreYouSureEmailExistsBodyText', { email : this.state.guestFormData.email})} :
                        <ul>
                          { this.state.guestFormData.email !== undefined && (<li>{this.state.guestFormData.email}</li>) }
                        </ul>
                      </div> 
                  </DialogContent>
                  <DialogActions>
                    <Button
                      onClick={this.guestUserEmailAlreadyExistsNoBtn}
                      color='primary'
                      className={classes.primaryButton}
                    >
                      {t('Users.AreYouSureEmailExistsNoButton')}
                    </Button>
                    <Button
                      onClick={this.guestUserEmailAlreadyExistsYesBtn}
                      color='primary' 
                      className={classes.primaryButton}
                    >
                      {t('Users.AreYouSureEmailExistsButton')}
                    </Button>
                  </DialogActions>
                </Dialog>

                <Dialog
                  open={(this.state.showGuestUserDialog || false)}
                  onClose={this.handleClose} 
                >
                  {this.state.loader ? (
                    <div className={classes.spinner}>
                      <img className={classes.spinnerImage} src={spinner} alt='loading' />
                    </div>
                  ) : null}
                  <ValidatorForm
                      ref='guestUserform'
                      onSubmit={(e) => {
                        e.preventDefault();
                        if(!this.state.guestFormData.emailExistsUser){ 
                          this.handleGuestFormSubmit(e);
                        }else {
                          this.setState({
                            dialogEmailAlreadyExistsForGuest: true
                          })
                        }                          
                      }}>
                      <DialogTitle id="form-dialog-title">
                        <IconButton 
                          onClick={this.handleClose}
                          sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                          }}
                        >
                          <CloseIcon />
                        </IconButton> 
                        
                      </DialogTitle>
                      <DialogContent>   
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12}>
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                  height: '100px', 
                                }}
                              >
                                <img
                                  alt={t("Home.SecureBadgePopup.YourSecureBadge")}
                                  src={secureBadgeImg}
                                  style={{ maxWidth: '100%', maxHeight: '100%' }}
                                /> 
                              </Box>

                              <Grid item xs={12} sm={12}>
                                <Box sx={{ margin: "0 0 20px 0"}}>
                                  <Stepper activeStep={this.state.activeStep}>
                                      {steps.map((label) => (
                                          <Step key={label} style={{padding:'0px'}}>
                                              <StepLabel>{label}</StepLabel>
                                          </Step>
                                      ))}
                                  </Stepper>                        
                                </Box>
                              </Grid>
                            </Grid>
                            {/* Guest form starts */}
                            { (this.state.activeStep === 0) && (

                                <Grid item xs={12} sm={12}>  

                                <Grid container spacing={2}>
                                  <Grid item xs={12} sm={12}>
                                    <SearchableSelect
                                      label={t('Users.UserDetails.ParentAccount')}
                                      items={(this.state.accountValues || []).map((account) => ({
                                        id: account.value,
                                        name: account.label,
                                      }))}
                                      value={this.state.parent_account_id || ''}
                                      onChange={this.handleParentAccountChange}
                                      placeholder="Search parent accounts..."
                                      id="guest-parent-account-select"
                                      fullWidth={true}
                                      sx={{ m: '16px 0' }}
                                      variant="standard"
                                      disabled={Boolean(readOnly)}
                                    />
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2} >
                                    {/* First Name Field */}
                                    <Grid item xs={12} sm={6}> 
                                        <TextValidator
                                          autoFocus
                                          className={classes.halfTextField}
                                          margin='normal'
                                          name="firstName"
                                          value={this.state.guestFormData.firstName}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                            maxLength: 50,
                                            autoComplete: 'off',
                                          }}
                                          label={t('Users.UserDetails.FirstName')} 
                                          placeholder=''
                                          style={{ width: '100%' }}
                                          onChange={this.handleGuestFormDataChange}
                                          validators={[
                                            'required',
                                            'matchRegexp:^[a-zA-Z ]*$',
                                          ]}
                                          errorMessages={[
                                            t('Validation.FirstNameRequired'),
                                            t('Validation.UseAlphabets'),
                                          ]}
                                          variant='standard'
                                        />
                                    </Grid>
                                    {/* Last Name Field */}
                                    <Grid item xs={12} sm={6}> 
                                        <TextValidator
                                          name="lastName"
                                          className={classes.halfTextField}
                                          margin='normal'
                                          value={this.state.guestFormData.lastName}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                            maxLength: 50,
                                            autoComplete: 'off',
                                          }}
                                          label={t('Users.UserDetails.LastName')} 
                                          placeholder=''
                                          style={{ width: '100%' }}
                                          onChange={this.handleGuestFormDataChange}
                                          validators={[
                                            'required',
                                            'matchRegexp:^[a-zA-Z ]*$',
                                          ]}
                                          errorMessages={[
                                            t('Validation.LastNameRequired'),
                                            t('Validation.UseAlphabets'),
                                          ]}
                                          variant='standard'
                                        />
                                    </Grid> 
                                </Grid>

                                <Grid container spacing={2}>
                                    {/* Email Field */}
                                    <Grid item xs={12} sm={6}> 

                                        <TextValidator 
                                          className={classes.halfTextField}
                                          margin='normal'
                                          name="email"
                                          value={this.state.guestFormData.email}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                            maxLength: 50,
                                            autoComplete: 'off',
                                          }}
                                          label={t('Users.UserDetails.EmailAddress')} 
                                          placeholder=''
                                          style={{ width: '100%' }}
                                          onChange={this.handleGuestFormDataChange}
                                          validators={['isEmail', 'isValidEmail']}
                                          errorMessages={[
                                            t('Validation.EmailIsNotValid'),
                                            t('Validation.EmailIsNotValid'),
                                          ]}
                                          variant='standard'
                                        />
                                    </Grid>
                                    {/* location drop down Field */}
                                    <Grid item xs={12} sm={6}>
                                        <SearchableSelect
                                            label={t('Users.PreferredLocation')}
                                            items={preferredLocationItems}
                                            value={preferredLocationValue}
                                            onChange={this.handleBoxChange}
                                            placeholder="Search locations..."
                                            id="preferred-location-select-standard"
                                            fullWidth={true}
                                            sx={{ m: '16px 0' }}
                                            variant="standard"
                                          />
                                    </Grid>
                                    
                                </Grid>

                                <Grid container spacing={2} > 
                                  
                                      <Grid item xs={12} sm={6}>

                                            <FormControl
                                                variant='standard' 
                                                fullWidth
                                              >
                                            <InputLabel id='preferred-group-label2'>
                                              {t('Group.User.GroupControlTitle')}
                                            </InputLabel>
                                            <Select
                                              
                                              labelId='preferred-group-label2'
                                              id='preferred-group-select-standard2'
                                              value={groupId}
                                              readOnly={readOnly}
                                              onChange={this.handleInputChange} 
                                              label={t('Group.User.GroupControlTitle')}
                                              sx={{ height: '41px'}}
                                            >
                                              {Array.isArray(filteredGroup) &&
                                                filteredGroup.length > 0 &&
                                                !loggedInUserHasGroup && (
                                                <MenuItem value="">
                                                  {t('Group.User.GroupControlTitle')}
                                                </MenuItem>
                                              )}
                                              {filteredGroup.length > 0 ? (
                                                filteredGroup.map((type, index) => (
                                                  <MenuItem
                                                    key={index}
                                                    value={type.id}
                                                    className={classes.locationType}
                                                  >
                                                    {type.name}
                                                  </MenuItem>
                                                )))
                                                :
                                                <MenuItem disabled>{t('Groups.Dialog.NoGroup')}</MenuItem>
                                              }
                                            </Select>
                                          </FormControl>

                                      </Grid>
                                      <Grid item xs={12} sm={6}> 
                                        <FormControl
                                            variant='standard'
                                            fullWidth
                                            error={Boolean(this.state.guestFormData.rolesError)}
                                          >
                                        <InputLabel htmlFor='select-multiple-chip2'>
                                          {t('Users.UserDetails.Roles')}
                                        </InputLabel>
                                        <Select
                                            multiple
                                            fullWidth
                                            readOnly={readOnly}
                                            value={this.state.chipstores}
                                            onChange={this.handleStoreChange}
                                            input={<Input id='select-multiple-chip2' />}
                                            renderValue={(selected) => (
                                              <div className={classes.chips}>
                                                {selected.map((value) => (
                                                  <Chip
                                                    key={value.id}
                                                    label={value.name}
                                                    className={classes.chip}
                                                  />
                                                ))}
                                              </div>
                                            )}
                                            MenuProps={MenuProps}
                                            sx={{ height: '41px'}}
                                          >
                                            {(this.state && this.state.roleLookupValues) !==
                                              undefined &&
                                              this.state.roleLookupValues.map &&
                                              this.state.roleLookupValues.map((item) => (
                                                <MenuItem key={item.id} value={item}>
                                                  <Checkbox
                                                    checked={
                                                      this.state &&
                                                      this.state.roles &&
                                                      this.state.roles.map &&
                                                      this.state.roles
                                                        .map((x) => x.id)
                                                        .indexOf(item.id) > -1
                                                    }
                                                  />
                                                  <ListItemText primary={t(item.name)} />
                                                </MenuItem>
                                              ))}
                                          </Select>
                                          {this.state.guestFormData.rolesError && (
                                            <FormHelperText error>
                                              {this.state.guestFormData.rolesError}
                                            </FormHelperText>
                                          )}
                                          </FormControl>
                                      </Grid>
                                </Grid>
                                                
                                </Grid>

                            )}
                            {/* Guest form ends */}

                            { (this.state.activeStep === 1) &&  ( <Grid container spacing={2} >
                                  <Grid item xs={12} sm={6}>
                                    <Box
                                      sx={{ 
                                        padding: 2,
                                        textAlign: 'center',
                                      }}
                                    >
                                      <Typography
                                          variant="h3"
                                          component="h3"
                                          sx={{ fontSize:'1.5rem', fontWeight:'bold', marginBottom:'30px', color: '#3A414A'}}
                                        >
                                        {t("Home.SecureBadgePopup.instruction1")}
                                        </Typography>
                  
                  
                                        <Typography
                                          variant="h5"
                                          component="h5"
                                          sx={{ fontSize:'1.1rem' }}
                                        >
                                        {t("Home.SecureBadgePopup.instruction2")}
                                        </Typography>
                                    </Box>
                                  </Grid>
                                  
                                  {/* Right Column */}
                                  <Grid item xs={12} sm={6}>
                                    <Box
                                      sx={{
                                        padding: 2,
                                        textAlign: 'center',
                                      }}
                                    >
                                        <FormControl component="fieldset">
                                          <RadioGroup aria-label="options" name="secureBadgeUserType" value={this.state.secureBadgeAction} onChange={this.handleGuestFormUserAction} > 
                                          { (Boolean(this.state.contextMenuUsed) === false) && (
                                              <React.Fragment>
                                              <FormControlLabel value="print" control={<Radio />} label={t("Home.SecureBadgePopup.Print")} sx={{ '& .MuiFormControlLabel-label' : { fontSize: '1.2rem' }}}/>                                              
                                              <FormControlLabel value="download" control={<Radio />} label={t("Home.SecureBadgePopup.Download")} sx={{ '& .MuiFormControlLabel-label' : { fontSize: '1.2rem' }}} /> 
                                              </React.Fragment>
                                            )}
                                              <FormControlLabel value="email" control={<Radio />} label={t("Home.SecureBadgePopup.Email")} sx={{ '& .MuiFormControlLabel-label' : { fontSize: '1.2rem' }}} />

                                            { ((this.state.secureBadgeAction === 'email') || (Boolean(this.state.handleGuestUserEmail) === true)) ? (
                                                  <TextValidator 
                                                    className={classes.halfTextField}
                                                    margin='normal'
                                                    name="email"
                                                    value={this.state.guestFormData.email}
                                                    inputProps={{
                                                      readOnly: Boolean(readOnly),
                                                      maxLength: 50,
                                                      autoComplete: 'off',
                                                    }}
                                                    label={t('Users.UserDetails.EmailAddress')} 
                                                    placeholder={this.state.guestFormData.email}
                                                    style={{ width: '100%' }}
                                                    onChange={this.handleGuestFormDataChange}
                                                    validators={['isEmail', 'nextEmailalreadyExists']}
                                                    errorMessages={[
                                                      t('Validation.EmailIsNotValid'),
                                                      t('Validation.EmailAlreadyExists'),
                                                    ]}
                                                    variant='standard'
                                                  /> 
                                            ) : "" }
                                          </RadioGroup>
                                        </FormControl>
                                    </Box>
                                  </Grid>
                            </Grid>) }

                        </Grid>
                        
                      </DialogContent> 
                      <DialogActions sx={{ padding: '10px 20px 10px 20px', justifyContent: 'space-between' }}> 
                          <Typography
                            variant="span"
                            component="span" 
                          > 
                          { (Boolean(this.state.contextMenuUsed) === false) ? (this.state.secureBadgeExpiry !== null && Boolean(this.state.secureBadgeExpiry) !== false) ? 
                          t("Home.SecureBadgePopup.YourBadgeExpiry", {duration : this.state.secureBadgeExpiry})
                          : t("Home.SecureBadgePopup.YourBadgeExpiry", {duration : '24 hours'})
                          : ''}
                          </Typography>
                          <div>  
                            { (this.state.activeStep === 0) &&                           
                            ( <Button
                              disabled={this.state.isCreateGuestButtonDisabled}
                              type='submit'
                              color='primary'
                              sx={{ marginLeft: '8px' }}                       
                              className={classes.primaryButton}
                            >
                              {t("Home.SecureBadgePopup.CreateGuestUser")}
                            </Button>
                            )}

                            { this.state.guestQrCodeImg && (this.state.activeStep === 1) && (<Button
                              type='button'
                              color='primary'
                              sx={{ marginLeft: '8px' }} 
                              className={classes.primaryButton}
                              onClick={this.handleConfirmAction}
                            >
                              {t("Home.SecureBadgePopup.Confirm")}
                            </Button>)}

                          </div>
                      </DialogActions>
                  </ValidatorForm>
                </Dialog>

                {this.state.guestQrCodeImg && this.state.secureBadgeAction === 'print' && (<Box component='div' id='print_secure_badge_qr' className='secure-badge-print-modal'>
                          <PrintTemplate>
                            <Box className='modal-dialog'>
                              <Dialog
                                open={this.state.printGuestSecureBadgeQR || false} 
                                PaperProps={{
                                  sx: { borderRadius: '0px', width: '320px', height: '400px' },
                                }}
                              >
                                <Box className='modal-content'>
                                  <DialogContent className='modal-body' sx={{ p: '10px' }}>
                                    <Box component="div" id="printableArea" className={classes.boxDesign}>
                                      <Box 
                                        component="img"
                                        className="secure-badge-print-image"
                                        sx={{
                                          width: 300,
                                          height: 300,
                                          display: 'flex',
                                          justifyContent: 'center',
                                          objectFit: 'cover',
                                          borderRadius: '8px',
                                          boxShadow: 3,
                                        }}
                                        alt={t("Home.SecureBadgePopup.YourSecureBadge")}
                                        src={this.state.guestQrCodeImg}
                                      />
                                    </Box>
                                  </DialogContent>
                                </Box>
                              </Dialog>
                            </Box>
                          </PrintTemplate>
                        </Box>) }

{/* Add guest user popup ends  */}

        {/* Add Installer User Dialog */}
        <Dialog
          open={(this.state.showInstallerDialog || false)}
          onClose={this.handleClose}
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img className={classes.spinnerImage} src={spinner} alt='loading' />
            </div>
          ) : null}
          <ValidatorForm
            onSubmit={(e) => {
              e.preventDefault();
              this.handleInstallerFormSubmit(e);
            }}>
            <DialogTitle id="form-dialog-title">
              {t("Users.Installer.DialogTitle")}
              <IconButton
                onClick={this.handleClose}
                sx={{
                  position: 'absolute',
                  right: 8,
                  top: 8,
                }}
              >
                <CloseIcon />
              </IconButton>

            </DialogTitle>
            <DialogContent>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={12}>
                  <SearchableSelect
                    label={t('Users.UserDetails.ParentAccount')}
                    items={(this.state.accountValues || []).map((account) => ({
                      id: account.value,
                      name: account.label,
                    }))}
                    value={this.state.parent_account_id || ''}
                    onChange={this.handleInstallerParentAccountChange}
                    placeholder="Search parent accounts..."
                    id="installer-parent-account-select"
                    fullWidth={true}
                    sx={{ m: '16px 0' }}
                    variant="standard"
                    disabled={Boolean(readOnly)}
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextValidator
                    className={classes.halfTextField}
                    margin='normal'
                    name="firstName"
                    value={this.state.installerUserDetails.firstName}
                    inputProps={{
                      readOnly: true,
                      maxLength: 50,
                      autoComplete: 'off',
                    }}
                    label={t('Users.UserDetails.FirstName')}
                    placeholder=''
                    style={{ width: '100%' }}
                    variant='standard'
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <TextValidator
                    name="lastName"
                    className={classes.halfTextField}
                    margin='normal'
                    value={this.state.installerUserDetails.lastName}
                    inputProps={{
                      readOnly: true,
                      maxLength: 50,
                      autoComplete: 'off',
                    }}
                    label={t('Users.UserDetails.LastName')}
                    placeholder=''
                    style={{ width: '100%' }}
                    variant='standard'
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <SearchableSelect
                    label={t('Users.PreferredLocation')}
                    items={(this.state.selectedAccountBoxList || []).map((box) => ({ id: box.id, name: box.value }))}
                    value={selectedBoxId || (this.state.selectedAccountBoxList && this.state.selectedAccountBoxList[0] && this.state.selectedAccountBoxList[0].id) || ''}
                    onChange={this.handleBoxChange}
                    placeholder="Search locations..."
                    id="preferred-location-select-edit-user"
                    fullWidth={true}
                    variant="standard"
                  />
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl
                    variant='standard'
                    fullWidth
                  >
                    <InputLabel htmlFor='select-multiple-chip2'>
                      {t('Users.UserDetails.Roles')}
                    </InputLabel>
                    <Select
                      multiple
                      fullWidth
                      readOnly={readOnly}
                      value={this.state.chipstores}
                      onChange={this.handleStoreChange}
                      input={<Input id='select-multiple-chip2' />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((value) => (
                            <Chip
                              key={value.id}
                              label={value.name}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                    >
                      {(this.state && this.state.roleLookupValues) !==
                        undefined &&
                        this.state.roleLookupValues.map &&
                        this.state.roleLookupValues.map((item) => (
                          <MenuItem key={item.id} value={item}>
                            <Checkbox
                              checked={
                                this.state &&
                                this.state.roles &&
                                this.state.roles.map &&
                                this.state.roles
                                  .map((x) => x.id)
                                  .indexOf(item.id) > -1
                              }
                            />
                            <ListItemText primary={t(item.name)} />
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'flex-end' }}>
              <Button
                disabled={this.state.isCreateGuestButtonDisabled}
                type='submit'
                color='primary'
                sx={{ marginLeft: '8px' }}
                className={classes.primaryButton}
              >
                {t('Home.SecureBadgePopup.Print')}
              </Button>
            </DialogActions>
          </ValidatorForm>
        </Dialog>

        <Box component='div'>
          <PrintTemplate>
            <Dialog
              open={this.state.printInstallerSecureBadge || false}
              PaperProps={{
                sx: { borderRadius: '0px', width: '800px', padding: 2 },
              }}
            >
              <DialogContent sx={{ p: 4 }}>
                <Box sx={{ mb: 2 }}>
                  <Typography variant="subtitle2" align="center">
                    {t('Users.Installer.SingleOnly')}
                  </Typography>
                </Box>

                <Typography variant="body1" fontWeight={600}>
                  {t('Accounts.AccountDetail.Account')}: {this.state.installerUserDetails.firstName}
                </Typography>
                <Typography variant="body1" fontWeight={600}>
                  {t('Report.Assign.Location')}: {this.state.installerUserDetails.lastName}
                </Typography>
                <Typography variant="body1" fontWeight={600} mt={1}>
                  {t('Users.Installer.Address')}
                </Typography>
                <Typography variant="body2">
                  {[
                    this.state.installBadgeBoxLocation &&
                    this.state.installBadgeBoxLocation.address_line_1 &&
                    this.state.installBadgeBoxLocation.address_line_1.trim(),
                    this.state.installBadgeBoxLocation &&
                    this.state.installBadgeBoxLocation.address_line_2 &&
                    this.state.installBadgeBoxLocation.address_line_2.trim()
                  ]
                    .filter(Boolean)
                    .join(', ')}
                </Typography>
                <Typography variant="body2" mb={2}>
                  {[
                    this.state.installBadgeBoxLocation &&
                    this.state.installBadgeBoxLocation.city &&
                    this.state.installBadgeBoxLocation.city.trim(),
                    this.state.installBadgeBoxLocation &&
                    this.state.installBadgeBoxLocation.state &&
                    this.state.installBadgeBoxLocation.state.trim(),
                    this.state.installBadgeBoxLocation &&
                    this.state.installBadgeBoxLocation.zip &&
                    this.state.installBadgeBoxLocation.zip.trim()
                  ]
                    .filter(Boolean)
                    .join(', ')}
                </Typography>

                <Typography variant="body1" fontWeight={600} mb={1}>
                  {t('Users.Installer.GettingStarted')}
                </Typography>
                <Box component="ol" sx={{ pl: 3, mb: 2 }}>
                  <li>{t('Users.Installer.Instruction1')}</li>
                  <li>{t('Users.Installer.Instruction2')}</li>
                  <li>{t('Users.Installer.Instruction3')}</li>
                  <li>{t('Users.Installer.Instruction4')}</li>
                  <li>{t('Users.Installer.Instruction5')}</li>
                  <li>{t('Users.Installer.Instruction6')}</li>
                  <li>{t('Users.Installer.Instruction7')}</li>
                </Box>
                <Box display="flex" justifyContent="space-between" mt={6}>
                  <Box>
                    <img
                      src={this.state.installerSecureBadgeQR}
                      alt="Secure Badge"
                      style={{
                        width: 250,
                        height: 250,
                        borderRadius: 8,
                        boxShadow: "0 0 5px rgba(0,0,0,0.2)",
                      }}
                    />
                    <Typography variant="body2" mt={2}>
                      {t('Users.Installer.UseBefore24')}
                    </Typography>
                    <Typography variant="caption">{t('Users.Installer.CreatedOn')}{formattedDate}</Typography>
                  </Box>

                  <Box
                    border="1px solid gray"
                    borderRadius={1}
                    p={2}
                    width={250}
                    height={140}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    sx={{ fontSize: 14 }}
                  >
                    <b>{t('Users.Installer.ConnectPower')}</b>
                    <span>{t('Users.Installer.ThenCall')}</span>
                    <br />
                    <b>(949) 535-4490 Ext 2</b>
                    <span>{t('Users.Installer.VerifyConnectivity')}</span>
                  </Box>
                </Box>
              </DialogContent>
            </Dialog>
          </PrintTemplate>
        </Box>
        {/* Add Installer User Dialog */}

        <Dialog
          maxWidth='md'
          open={this.state.showNewUserDialog || false}
          onClose={this.handleClose}
          aria-labelledby='form-dialog-title'
          classes={{ paper: classes.Paper }}
        >
          {this.state.loader ? (
            <div className={classes.spinner}>
              <img
                className={classes.spinnerImage}
                src={spinner}
                alt='loading'
              />
            </div>
          ) : null}
          <AppBar
            position='static'
            color='default'
            sx={{ backgroundColor: '#f5f5f5 !important' }}
          >
            <Tabs
              value={this.state.selectedTab}
              onChange={this.handleTabChange}
              indicatorColor='primary'
              textColor='primary'
              variant={null}
            >
              <Tab
                label={t('Users.UserDetails.UserDetailsTitle')}
                style={{ minWidth: '160px' }}
              />
              {(this.state.operation === 'Edit' ||
                this.state.operation === 'View') && (
                  <Tab
                    label={t('Users.Calendar.CalendarTitle')}
                    style={{ minWidth: '160px' }}
                  />
                )}
            </Tabs>
          </AppBar>
          <SwipeableViews
            style={{ maxWidth: '1025px' }}
            axis={theme && theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={this.state.selectedTab}
            onChangeIndex={() => this.handleChangeIndex}
          >
            <TabContainer dir={theme && theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <ValidatorForm
                  ref='form'
                  onSubmit={
                    this.state.operation === 'Add'
                      ? this.handleSubmit
                      : this.handleUpdate
                  }

                >
                  <DialogTitle id='form-dialog-title'>
                    {t(this.state.operation)} {t('Users.UserDetails.User')}
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText>
                      {this.state.operation === 'Add'
                        ? t('Users.UserDetails.UsersDetailsText')
                        : ''}

                      <span className={classes.errorDiv}>
                        {this.state.errorMessage}
                      </span>
                    </DialogContentText>
                    <SearchableSelect
                      label={t('Users.UserDetails.ParentAccount')}
                      items={(this.state.accountValues || []).map((account) => ({
                        id: account.value,
                        name: account.label,
                      }))}
                      value={this.state.parent_account_id || ''}
                    onChange={this.handleParentAccountChange}
                      placeholder="Search parent accounts..."
                      id="user-parent-account-select"
                      fullWidth={true}
                      sx={{ m: '16px 0' }}
                      variant="standard"
                      disabled={Boolean(readOnly || disableSelect)}
                    />
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            autoFocus
                            className={classes.halfTextField}
                            margin='normal'
                            value={user.first_name || this.state.first_name}
                            id='first_name'
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autoComplete: 'off',
                            }}
                            label={t('Users.UserDetails.FirstName')}
                            name='first_name'
                            type='first-name'
                            placeholder=''
                            style={{ width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Patient.Validation.EnterPatientRecordNumber'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='last_name'
                            value={user.last_name || this.state.last_name}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autoComplete: 'off',
                            }}
                            label={t('Users.UserDetails.LastName')}
                            name='last_name'
                            type='last-name'
                            style={{ width: '350px' }}
                            onChange={this.handleChange}
                            validators={[
                              'required',
                              'matchRegexp:^[a-zA-Z ]*$',
                            ]}
                            errorMessages={[
                              t('Validation.EnterLastName'),
                              t('Validation.UseAlphabets'),
                            ]}
                            variant='standard'
                          />
                        </div>
                        <div style={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            id='email'
                            disabled={['view', 'edit'].includes(
                              this.state.operation
                            )}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              autoComplete: 'off',
                            }}
                            value={String(
                              user.email || this.state.email
                            ).toLowerCase()}
                            label={t('Users.UserDetails.EmailAddress')}
                            type='email'
                            name='email'
                            style={{ width: '350px' }}
                            onChange={this.handleChange}
                            validators={['required', 'isEmail']}
                            errorMessages={[
                              t('Validation.EnterEmailAddress'),
                              t('Validation.EmailIsNotValid'),
                            ]}
                            variant='standard'
                          />
                          <TextValidator
                            className={classes.halfTextField}
                            margin='normal'
                            label={t('Users.UserDetails.PhoneNumber')}
                            value={user.phone || this.state.phone}
                            onChange={this.handleChange}
                            name='phone'
                            id='phone'
                            style={{ width: '350px' }}
                            InputProps={{
                              inputComponent: TextMaskCustom,
                              inputProps: {
                                autoComplete: 'off',
                                readOnly: Boolean(readOnly),
                              },
                            }}
                            variant='standard'
                            validators={['required', 'matchRegexp:^.{14,}$']}
                            errorMessages={[t('Validation.EnterPhoneNumber'), "enter valid number"]}
                          />

                        </div>
                        <Box sx={{ display: 'flex' }}>
                          <TextValidator
                            className={classes.halfTextField}
                            style={{ width: '350px' }}
                            fullWidth
                            margin='normal'
                            id='badge_id'
                            value={user.badge_id || this.state.badge_id}
                            inputProps={{
                              readOnly: Boolean(readOnly),
                              maxLength: 50,
                              autoComplete: 'off',
                            }}
                            label={t('Users.UserDetails.BadgeID')}
                            name='badge_id'
                            type='badge_id'
                            onChange={this.handleChange}
                            variant='standard'
                          />
                          <FormControl
                            variant='standard'
                            sx={{ m: '16px 0', minWidth: 347 }}
                          >
                            <InputLabel id='preferred-language-label'>
                              {t('Users.UserDetails.PreferredLanguage')}
                            </InputLabel>
                            <Select
                              labelId='preferred-language-label'
                              id='preferred-language-select-standard'
                              value={preferLanguage || ''}
                              readOnly={readOnly}
                              onChange={this.onChangePreferredLanguage}
                              label={t('Users.UserDetails.PreferredLanguage')}
                            >
                              {this.state &&
                                this.state.preferredLanguage.map(
                                  (item, index) => (
                                    <MenuItem
                                      key={index}
                                      value={item && item.id}
                                      selected
                                    >
                                      {item && item.label}
                                    </MenuItem>
                                  )
                                )}
                            </Select>
                          </FormControl>
                        </Box>
                        <Box sx={{ display: 'flex' }}>
                          <SearchableSelect
                            label={t('Users.PreferredLocation')}
                            items={preferredLocationItems}
                            value={preferredLocationValue}
                            onChange={this.handleBoxChange}
                            placeholder="Search locations..."
                            id="preferred-location-select-guest"
                            fullWidth={false}
                            sx={{ m: '16px 0', minWidth: 347 }}
                            variant="standard"
                          />
                          <div style={{ marginLeft: '3.5%' }}>
                            <FormControl
                              variant='standard'
                              sx={{ m: '16px 0', minWidth: 347 }}
                            >
                              <InputLabel id='preferred-group-label'>
                                {t('Group.User.GroupControlTitle')}
                              </InputLabel>
                              <Select
                                labelId='preferred-group-label'
                                id='preferred-group-select-standard'
                                value={groupId || ""}
                                readOnly={readOnly}
                                onChange={this.handleInputChange}
                                variant='standard'
                                label={t('Group.User.GroupControlTitle')}
                              >
                                {Array.isArray(filteredGroup) &&
                                  filteredGroup.length > 0 &&
                                  !loggedInUserHasGroup && (
                                  <MenuItem value="">
                                    {t('Group.User.GroupControlTitle')}
                                  </MenuItem>
                                )}
                                {Array.isArray(filteredGroup) && filteredGroup.length > 0 ? (
                                  filteredGroup.map((type, index) => (
                                    <MenuItem
                                      key={type.id || index}
                                      value={type.id}
                                      className={classes.locationType}
                                    >
                                      {type.name}
                                    </MenuItem>
                                  ))
                                ) : (
                                  <MenuItem disabled value="">
                                    {t('Groups.Dialog.NoGroup')}
                                  </MenuItem>
                                )}
                              </Select>
                            </FormControl>
                          </div>
                        </Box>
                      </div>
                      <div className={classes.rightChild}>
                        <div className={classes.dropbox}>
                          {readOnly ? (
                            <div>
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </div>
                          ) : (
                            <Dropzone
                              id='avatardropzone'
                              onDrop={this.handleDrop.bind(this)}
                              className={classes.innerBox}
                            >
                              {!this.state.avatarPreview && (
                                <AddUserImage className={classes.dropImage} />
                              )}
                              {this.state.avatarPreview && (
                                <img
                                  alt=''
                                  src={this.state.avatarPreview}
                                  className={classes.dropPic}
                                />
                              )}
                            </Dropzone>
                          )}
                        </div>
                        <br />
                        <div variant='caption' style={{ paddingTop: '40px' }}>
                          <p className={classes.captionText}>
                            {t('Users.UserDetails.UploadImage')}
                          </p>
                          <Button onClick={this.removeImg}>
                            {t('Users.UserDetails.RemoveImage')}
                          </Button>
                        </div>
                      </div>
                    </div>
                    <br />
                    <InputLabel htmlFor='select-multiple-chip'>
                      {t('Users.UserDetails.Roles')}
                    </InputLabel>
                    <Select
                      multiple
                      fullWidth
                      readOnly={readOnly}
                      value={this.state.chipstores}
                      onChange={this.handleStoreChange}
                      input={<Input id='select-multiple-chip' />}
                      renderValue={(selected) => (
                        <div className={classes.chips}>
                          {selected.map((value) => (
                            <Chip
                              key={value.id}
                              label={value.name}
                              className={classes.chip}
                            />
                          ))}
                        </div>
                      )}
                      MenuProps={MenuProps}
                      error={Boolean(this.state.rolesError)}
                    >
                      {(this.state && this.state.roleLookupValues) !==
                        undefined &&
                        this.state.roleLookupValues.map &&
                        this.state.roleLookupValues.map((item) => (
                          <MenuItem key={item.id} value={item}>
                            <Checkbox
                              checked={
                                this.state &&
                                this.state.roles &&
                                this.state.roles.map &&
                                this.state.roles
                                  .map((x) => x.id)
                                  .indexOf(item.id) > -1
                              }
                            />
                            <ListItemText primary={t(item.name)} />
                          </MenuItem>
                        ))}
                    </Select>
                    {this.state.rolesError && (
                      <FormHelperText error>{this.state.rolesError}</FormHelperText>
                    )}
                    <br />
                  </DialogContent>
                  <div style={{ bottom: '0', width: '100%' }}>
                    <DialogActions sx={{ padding: '15px 12px 9px 4px' }}>
                      <Button
                        onClick={this.handleClose}
                        color='primary'
                        className={classes.primaryButton}
                      >
                        {this.state.operation === 'View'
                          ? t('Users.CloseButton')
                          : t('Users.CancelButton')}
                      </Button>
                      {this.state.operation !== 'View' && (
                        <Button
                          type='submit'
                          disabled={this.state.isButtonDisabled}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {this.state.operation === 'Edit'
                            ? t('Users.UpdatePatientButton')
                            : t('Users.AddPatientButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </ValidatorForm>
              </div>
            </TabContainer>
            <TabContainer dir={theme && theme.direction}>
              <div className={classes.paddedBoxDivEdit}>
                <ValidatorForm
                  ref='form'
                  onSubmit={this.handleSubmitScheduleCalendar}
                >
                  <DialogTitle
                    id='form-dialog-title'
                    className={classes.dialogTitle}
                  >
                    {t('Users.Calendar.WorkSchedule')}
                  </DialogTitle>
                  <DialogContent>
                    <div className={classes.twoChildren}>
                      <div className={classes.leftChild}>
                        <Grid container>
                          <Grid item xs={6}>
                            <FormControl
                              className={classes.halfTextField}
                              style={{ marginTop: '16px', marginBottom: '8px' }}
                            >
                              <LocalizationProvider
                                dateAdapter={DateAdapter}
                                locale={locale}
                              >
                                <div>
                                  <div className='picker'>
                                    <DesktopDatePicker
                                      keyboard
                                      clearable
                                      value={
                                        this.state && this.state.workDayStarts
                                      }
                                      disableFuture
                                      onChange={this.handleWorkDayStartsChange}
                                      disabled={readOnly}
                                      style={{ width: '400px' }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            'Users.Calendar.WorkDayStarts'
                                          )}
                                          variant='standard'
                                          sx={{
                                            '&.MuiFormControl-root': {
                                              width: '400px',
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                    {/* <TimePicker
                                      keyboard
                                      ampm={true}
                                      margin='normal'
                                      id='time-picker'
                                      label='Work day starts'
                                      value={
                                        this.state && this.state.workDayStarts
                                      }
                                      onChange={this.handleWorkDayStartsChange}
                                      KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                      }}
                                      style={{ width: '400px' }}
                                      disabled={readOnly}
                                    /> */}
                                  </div>
                                </div>
                              </LocalizationProvider>
                            </FormControl>
                            <FormControl
                              className={classes.halfTextField}
                              style={{
                                marginTop: '16px',
                                marginBottom: '27px',
                              }}
                            >
                              <LocalizationProvider
                                dateAdapter={DateAdapter}
                                locale={locale}
                              >
                                <div>
                                  <div className='picker'>
                                    <DesktopDatePicker
                                      keyboard
                                      clearable
                                      value={
                                        this.state && this.state.workDayEnds
                                      }
                                      //format="MM/DD/YYYY"
                                      //placeholder="12/31/1984"
                                      disableFuture
                                      onChange={this.handleWorkDayEndsChange}
                                      disabled={readOnly}
                                      style={{ width: '400px' }}
                                      renderInput={(params) => (
                                        <TextField
                                          {...params}
                                          label={t(
                                            'Users.Calendar.WorkDayEnds'
                                          )}
                                          variant='standard'
                                          sx={{
                                            '&.MuiFormControl-root': {
                                              width: '400px',
                                            },
                                          }}
                                        />
                                      )}
                                    />
                                    {/* <TimePicker
                                      keyboard
                                      ampm={true}
                                      margin='normal'
                                      id='time-picker'
                                      label='Work day starts'
                                      value={
                                        this.state && this.state.workDayStarts
                                      }
                                      onChange={this.handleWorkDayStartsChange}
                                      KeyboardButtonProps={{
                                        'aria-label': 'change time',
                                      }}
                                      style={{ width: '400px' }}
                                      disabled={readOnly}
                                    /> */}
                                  </div>
                                </div>
                              </LocalizationProvider>
                            </FormControl>
                            <Typography
                              variant='title'
                              style={{ marginTop: '25px' }}
                              className={classes.dialogTitle}
                            >
                              {t('Users.Calendar.CalendarOptions')}
                            </Typography>
                            <div>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    disabled={Boolean(readOnly)}
                                    name='defaultReminder'
                                    checked={this.state.defaultReminder}
                                    onChange={this.handleCheckboxChange}
                                    value={this.state.defaultReminder}
                                    color='primary'
                                  />
                                }
                                label={t('Users.Calendar.DefaultReminder')}
                              />
                            </div>
                            {this.state.defaultReminder === false && (
                              <FormControl style={{ width: '350px' }}>
                                <SelectValidator
                                  fullWidth
                                  autoFocus={false}
                                  id='demo-controlled-open-select'
                                  name='ReminderSelect'
                                  label={t('Users.Calendar.Reminder')}
                                  open={
                                    this.state &&
                                    this.state.isOpenReminderSelect
                                  }
                                  onClose={this.handleCloseReminderSelect}
                                  onOpen={this.hanldeOpenReminderSelect}
                                  onChange={this.handleCheckboxChange}
                                  value={
                                    this.state &&
                                    (this.state.reminderSelectID || '')
                                  }
                                  inputProps={{
                                    readOnly: Boolean(readOnly),
                                  }}
                                  variant='standard'
                                >
                                  <MenuItem
                                    value='5m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    5m
                                  </MenuItem>
                                  <MenuItem
                                    value='10m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    10m
                                  </MenuItem>
                                  <MenuItem
                                    value='15m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    15m
                                  </MenuItem>
                                  <MenuItem
                                    value='30m'
                                    className={classes.menuItem}
                                    sx={{ height: '46px' }}
                                  >
                                    30m
                                  </MenuItem>
                                </SelectValidator>
                              </FormControl>
                            )}
                          </Grid>
                          <Grid item xs={3}>
                            <div className={classes.boxDesign}>
                              <Typography
                                variant='title'
                                className={classes.dialogTitle}
                              >
                                {t('Users.Calendar.WorkWeek')}
                              </Typography>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='sunday'
                                      checked={this.state.sunday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.sunday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Sunday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='monday'
                                      checked={this.state.monday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.monday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Monday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='tuesday'
                                      checked={this.state.tuesday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.tuesday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Tuesday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='wednesday'
                                      checked={this.state.wednesday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.wednesday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Wednesday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='thursday'
                                      checked={this.state.thursday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.thursday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Thursday')}
                                    </span>
                                  }
                                />
                              </div>
                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='friday'
                                      checked={this.state.friday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.friday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Friday')}
                                    </span>
                                  }
                                />
                              </div>

                              <div>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      disabled={Boolean(readOnly)}
                                      name='saturday'
                                      checked={this.state.saturday}
                                      onChange={this.handleCheckboxChange}
                                      value={this.state.saturday}
                                      color='primary'
                                      inputProps={{
                                        readOnly: Boolean(readOnly),
                                      }}
                                    />
                                  }
                                  label={
                                    <span
                                      style={{
                                        color: '#000',
                                        fontSize: '0.875rem',
                                        fontWeight: 400,
                                        marginLeft: '1rem',
                                      }}
                                    >
                                      {t('Users.Calendar.Saturday')}
                                    </span>
                                  }
                                />
                              </div>
                            </div>
                          </Grid>
                          <Grid item xs={3}>
                            <div className={classes.boxDesign}>
                              <Typography
                                variant='title'
                                className={classes.dialogTitle}
                              >
                                {t('Users.Calendar.Notification')}
                              </Typography>
                              <div>
                                <FormControl component='fieldset'>
                                  <FormGroup>
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color='primary'
                                          name='email'
                                          value={this.state.emailNotify}
                                          checked={this.state.emailNotify}
                                          onChange={this.handleCheckboxChange}
                                          disabled={Boolean(readOnly)}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                          }}
                                        />
                                      }
                                      label={t('Users.Calendar.Email')}
                                    />
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color='primary'
                                          name='sms'
                                          value={this.state.smsNotify}
                                          checked={this.state.smsNotify}
                                          onChange={this.handleCheckboxChange}
                                          disabled={Boolean(readOnly)}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                          }}
                                        />
                                      }
                                      label={t('Users.Calendar.SMS')}
                                    />
                                    <FormControlLabel
                                      control={
                                        <Switch
                                          color='primary'
                                          name='push'
                                          value={this.state.pushNotify}
                                          checked={this.state.pushNotify}
                                          onChange={this.handleCheckboxChange}
                                          disabled={Boolean(readOnly)}
                                          inputProps={{
                                            readOnly: Boolean(readOnly),
                                          }}
                                        />
                                      }
                                      label={t('Users.Calendar.Push')}
                                    />
                                  </FormGroup>
                                </FormControl>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                    </div>
                  </DialogContent>
                  <div
                    style={{ position: 'absolute', bottom: '0', width: '100%' }}
                  >
                    <DialogActions sx={{ padding: '8px 12px 8px 8px' }}>
                      {(this.state.operation === 'Edit' ||
                        this.state.operation === 'View') && (
                          <Button
                            onClick={this.handleClose}
                            color='primary'
                            className={classes.primaryButton}
                          >
                            {this.state.operation === 'View'
                              ? t('Users.CloseButton')
                              : t('Users.CancelButton')}
                          </Button>
                        )}
                      {this.state.operation === 'Edit' && (
                        <Button
                          type='submit'
                          disabled={this.state.isDisabledScheduleButton}
                          color='primary'
                          className={classes.primaryButton}
                        >
                          {t('Users.Calendar.ScheduleCalendarButton')}
                        </Button>
                      )}
                    </DialogActions>
                  </div>
                </ValidatorForm>
              </div>
            </TabContainer>
          </SwipeableViews>
        </Dialog>
        <EnhancedTableToolbar
          numSelected={selected.length}
          add={this.addUser}
          addGuestUser={this.addGuestUser}
          addInstaller={this.addInstaller}
          userTypeEl={this.state.userTypeEl} 
          deleteUsers={this.deleteUsers}
          editUser={this.editUser}
          confirmDelete={this.confirmDelete}
          uadd={this.state.useradd}
          udelete={this.state.userdelete}
          exportCSV={this.exportCSV}
          handleUserTypeDropDown={this.handleUserTypeDropDown}
          handleDropDownClose={this.handleDropDownClose}
        />
        <div className={classes.tableWrapper}>
          <Divider
            style={{
              marginTop: '10px',
              height: '5px',
              borderColor: 'rgba(0, 0, 0, 0.12)',
              borderStyle: 'solid',
              borderBottomWidth: '5px',
            }}
          />
                    <ILocalAGGrid
            columnDefs={[
              {
                field: 'picture_url',
                headerName: t('Users.Picture'),
                sortable: false,
                filter: false,
                maxWidth: 90,
                cellRenderer: (params) => (
                  <Avatar alt="" src={params.data && params.data.picture_url} />
                ),
              },
              { field: 'name', headerName: t('Users.Name') },
              { field: 'username', headerName: t('Users.UserName') },
              {
                field: 'parent_account',
                headerName: t('Users.AssociatedAccount'),
                valueGetter: (p) =>
                  (p.data && p.data.parentAccount && p.data.parentAccount.name) || '',
                filter: false,
                sortable: false,
              },
              {
                field: 'selected_location_name',
                headerName: t('Users.PreferredLocation'),
                filter: false,
                sortable: false,
              },
              {
                field: 'email',
                headerName: t('Users.Email'),
                valueGetter: (p) =>
                  (p.data && p.data.contact && p.data.contact.email) ||
                  (p.data && p.data.email) ||
                  '',
              },
              {
                field: 'phone',
                headerName: t('Users.Phone'),
                valueGetter: (p) =>
                  (p.data && p.data.contact && p.data.contact.phone) ||
                  (p.data && p.data.phone) ||
                  '',
              },
              {
                field: 'roles',
                headerName: t('Users.Roles'),
                valueGetter: (p) =>
                  p.data && p.data.roles
                    ? Array.isArray(p.data.roles)
                      ? p.data.roles.map((r) => r.name || r).join(', ')
                      : p.data.roles
                    : '',
                filter: false,
                sortable: false,
              },
              {
                field: 'last_login_on',
                headerName: t('Users.LastLogin'),
                filter: false,
                valueGetter: (p) =>
                  p.data && p.data.last_login_on
                    ? this.convertToTimeZone(p.data.last_login_on)
                    : '',
              },
              {
                field: 'group_id',
                headerName: t('Groups.Dialog.Title'),
                valueGetter: (p) =>
                  (p.data && p.data.group && p.data.group.name) || '',
                filter: false,
                sortable: false,
              },
              {
                field: 'is_enabled',
                headerName: t('Users.Status'),
                valueGetter: (p) => {
                  const enabled =
                    p.data &&
                    (p.data.is_enabled === true || p.data.is_enabled === 'true');
                  return enabled ? t('Users.Enabled') : t('Users.DisableActions');
                },
              },
              {
                field: 'is_guest_user',
                headerName: t('Users.UserType'),
                filter: false,
                sortable: false,
                cellRenderer: (params) => {
                  const n = params.data;
                  if (!n) return null;
                  if ([true, 'true'].includes(n.is_guest_user)) {
                    return (
                      <Tooltip title={t('Users.GuestUserTooltip')}>
                        <AccessTimeIcon style={{ fontSize: 22, width: '70%' }} />
                      </Tooltip>
                    );
                  }
                  if ([true, 'true'].includes(n.expiration_start_on_login)) {
                    return (
                      <Tooltip title={t('Users.Installer.Tooltip')}>
                        <ManageAccountsIcon style={{ fontSize: 22, width: '70%' }} />
                      </Tooltip>
                    );
                  }
                  return '';
                },
              },
              getActionsColumn({
                headerName: t('Users.Actions'),
                onActionsClick: (event, params, menuHelpers) =>
                  this.openRowActionsMenu(event, params, menuHelpers),
              }),
            ]}
            defaultColDef={getDefaultColDef()}
            rowSelection="multiple"
            rowModelType="serverSide"
            cacheBlockSize={FilterObj.pageSize || 10}
            paginationPageSize={FilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={45}
            getRowId={(params) => params.data && params.data.id}
            onGridReady={this.onGridReady}
            onRowSelected={this.onRowSelected}
            onPaginationChanged={this.onPaginationChanged}
            getContextMenuItems={this.getContextMenuItems}
          />
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(EnhancedTable));



// WEBPACK FOOTER //
// ./src/components/user-list/index.js